import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import * as i1$1 from '@angular/material/legacy-snack-bar';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyChipsModule } from '@angular/material/legacy-chips';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { FormControl, Validators } from '@angular/forms';

class CargoChiefCommonsService {
    constructor() { }
}
CargoChiefCommonsService.ɵfac = function CargoChiefCommonsService_Factory(t) { return new (t || CargoChiefCommonsService)(); };
CargoChiefCommonsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CargoChiefCommonsService, factory: CargoChiefCommonsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CargoChiefCommonsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class CargoChiefCommonsModule {
}
CargoChiefCommonsModule.ɵfac = function CargoChiefCommonsModule_Factory(t) { return new (t || CargoChiefCommonsModule)(); };
CargoChiefCommonsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CargoChiefCommonsModule });
CargoChiefCommonsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FlexLayoutModule,
        MatLegacyDialogModule,
        MatDividerModule,
        MatLegacyButtonModule,
        MatLegacyInputModule,
        MatLegacyCardModule,
        MatIconModule,
        MatToolbarModule,
        MatLegacyProgressBarModule,
        MatLegacySnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatLegacyChipsModule,
        MatLegacySelectModule,
        MatExpansionModule,
        MatLegacyProgressSpinnerModule,
        MatStepperModule, FlexLayoutModule,
        MatLegacyDialogModule,
        MatDividerModule,
        MatLegacyButtonModule,
        MatLegacyInputModule,
        MatLegacyCardModule,
        MatIconModule,
        MatToolbarModule,
        MatLegacyProgressBarModule,
        MatLegacySnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatLegacyChipsModule,
        MatLegacySelectModule,
        MatExpansionModule,
        MatLegacyProgressSpinnerModule,
        MatStepperModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CargoChiefCommonsModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    FlexLayoutModule,
                    MatLegacyDialogModule,
                    MatDividerModule,
                    MatLegacyButtonModule,
                    MatLegacyInputModule,
                    MatLegacyCardModule,
                    MatIconModule,
                    MatToolbarModule,
                    MatLegacyProgressBarModule,
                    MatLegacySnackBarModule,
                    MatDatepickerModule,
                    MatNativeDateModule,
                    MatLegacyChipsModule,
                    MatLegacySelectModule,
                    MatExpansionModule,
                    MatLegacyProgressSpinnerModule,
                    MatStepperModule,
                ],
                exports: [
                    FlexLayoutModule,
                    MatLegacyDialogModule,
                    MatDividerModule,
                    MatLegacyButtonModule,
                    MatLegacyInputModule,
                    MatLegacyCardModule,
                    MatIconModule,
                    MatToolbarModule,
                    MatLegacyProgressBarModule,
                    MatLegacySnackBarModule,
                    MatDatepickerModule,
                    MatNativeDateModule,
                    MatLegacyChipsModule,
                    MatLegacySelectModule,
                    MatExpansionModule,
                    MatLegacyProgressSpinnerModule,
                    MatStepperModule,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CargoChiefCommonsModule, { imports: [FlexLayoutModule,
        MatLegacyDialogModule,
        MatDividerModule,
        MatLegacyButtonModule,
        MatLegacyInputModule,
        MatLegacyCardModule,
        MatIconModule,
        MatToolbarModule,
        MatLegacyProgressBarModule,
        MatLegacySnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatLegacyChipsModule,
        MatLegacySelectModule,
        MatExpansionModule,
        MatLegacyProgressSpinnerModule,
        MatStepperModule], exports: [FlexLayoutModule,
        MatLegacyDialogModule,
        MatDividerModule,
        MatLegacyButtonModule,
        MatLegacyInputModule,
        MatLegacyCardModule,
        MatIconModule,
        MatToolbarModule,
        MatLegacyProgressBarModule,
        MatLegacySnackBarModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatLegacyChipsModule,
        MatLegacySelectModule,
        MatExpansionModule,
        MatLegacyProgressSpinnerModule,
        MatStepperModule] }); })();

var NOTIFICATION_TYPES;
(function (NOTIFICATION_TYPES) {
    NOTIFICATION_TYPES["BidInviteCommand"] = "BidInviteCommand";
    NOTIFICATION_TYPES["LoadPostedCommand"] = "LoadPostedCommand";
    NOTIFICATION_TYPES["BrokerBidCounterCommand"] = "BrokerBidCounterCommand";
    NOTIFICATION_TYPES["BookingConfirmedCarrierCommand"] = "BookingConfirmedCarrierCommand";
    NOTIFICATION_TYPES["BidAcceptCommand"] = "BidAcceptCommand";
    NOTIFICATION_TYPES["BookingConfirmationEmailCommand"] = "BookingConfirmationEmailCommand";
    NOTIFICATION_TYPES["BidCounterEmailCommand"] = "BidCounterEmailCommand";
    NOTIFICATION_TYPES["BookingSignatureEmailCommand"] = "BookingSignatureEmailCommand";
    NOTIFICATION_TYPES["ProjectRateReceivedEmailCommand"] = "ProjectRateReceivedEmailCommand";
    NOTIFICATION_TYPES["TaskAssignedEmailCommand"] = "TaskAssignedEmailCommand";
    NOTIFICATION_TYPES["ProjectBestRateUpdatedCommand"] = "ProjectBestRateUpdatedCommand";
    NOTIFICATION_TYPES["CalculateProbabilityCommand"] = "CalculateProbabilityCommand";
    NOTIFICATION_TYPES["CarrierOpenedEmail"] = "CarrierOpenedEmail";
    NOTIFICATION_TYPES["CarrierNotAvailableRFPCommand"] = "CarrierNotAvailableRFPCommand";
    NOTIFICATION_TYPES["ProjectOwnerEmailCommand"] = "ProjectOwnerEmailCommand";
    NOTIFICATION_TYPES["UserCarrierMapAssignedEmailCommand"] = "UserCarrierMapAssignedEmailCommand";
    NOTIFICATION_TYPES["CheckProjectCommand"] = "CheckProjectCommand";
    NOTIFICATION_TYPES["DownloadCarriersEmailCommand"] = "DownloadCarriersEmailCommand";
    NOTIFICATION_TYPES["CarrierExcludedEmailCommand"] = "CarrierExcludedEmailCommand";
    NOTIFICATION_TYPES["LoadFileReceivedCommand"] = "LoadFileReceivedCommand";
})(NOTIFICATION_TYPES || (NOTIFICATION_TYPES = {}));
var DISPLAY_STATUSES;
(function (DISPLAY_STATUSES) {
    DISPLAY_STATUSES["9bcd4613-831e-4cb4-a76f-9166ce559fa6"] = "Active";
    DISPLAY_STATUSES["adc9769e-d2d7-4931-b373-f0221dcef6c2"] = "Confirmed";
    DISPLAY_STATUSES["9a0dc3e6-b451-4cf0-92e5-29d6e3695102"] = "Accepted";
    DISPLAY_STATUSES["d2261f74-2f48-4c01-a426-748ecb950912"] = "Countered";
    DISPLAY_STATUSES["269e4734-6ade-44a3-952b-6e619d0ac14b"] = "Declined";
    DISPLAY_STATUSES["47102931-c5cd-4732-bb75-00e73c702e9e"] = "Invited";
    DISPLAY_STATUSES["cb556a7e-8a46-4d08-850a-f2fa44e66673"] = "Viewed";
})(DISPLAY_STATUSES || (DISPLAY_STATUSES = {}));
const NOTIFICATION_MESSAGE = {
    BidInviteCommand: {
        title: 'Matching Load Found',
        alertContent: 'Open the C4 Extension for details',
    },
    LoadPostedCommand: {
        title: 'New Load Posted',
        alertContent: 'Open the C4 Extension for details.',
    },
    BrokerBidCounterCommand: {
        title: 'Counter offer Recieved.',
        alertContent: 'Open the C4 Extension for details.',
    },
    BookingConfirmedCarrierCommand: {
        title: 'Booking confirmed.',
        alertContent: 'Open the C4 Extension for details.',
    },
    BidAcceptCommand: {
        title: 'Bid Accepted.',
        alertContent: 'Open the C4 Extension for details.',
    },
    BookingConfirmationEmailCommand: {
        title: 'Booking confirmed',
        alertContent: 'Open the C4 Extension for details.',
    },
    BidCounterEmailCommand: {
        title: 'Offer countered.',
        alertContent: 'Open the C4 Extension for details.',
    },
    BookingSignatureEmailCommand: {
        title: 'Signed booking contract.',
        alertContent: 'Open the C4 Extension for details.',
    },
    ProjectRateReceivedEmailCommand: {
        title: 'Project Rate Received.',
        alertContent: 'Open for details.',
    },
    TaskAssignedEmailCommand: {
        title: 'New task assigned to you.',
        alertContent: 'Open for details.',
    },
    CarrierNotAvailableRFPCommand: {
        title: 'Carrier does not have any trucks for your request.',
        alertContent: 'Open for details.',
    },
    DownloadCarriersEmailCommand: {
        title: 'Your csv download is mailed to you',
        alertContent: 'Open for details.',
    },
    CarrierExcludedEmailCommand: {
        title: 'Carrier excluded',
        alertContent: 'Open for details.',
    },
};

const TIME_ZONES = [
    { label: 'Eastern Daylight Time (GMT-4)', value: '-0400' },
    { label: 'Central Daylight Time (GMT-5)', value: '-0500' },
    { label: 'Mountain Daylight Time (GMT-6)', value: '-0600' },
    { label: 'Pacific Daylight Time (GMT-7)', value: '-0700' },
    { label: 'Alaska Daylight Time (GMT-8)', value: '-0800' },
    { label: 'UTC', value: '+0000' }
];

const options = { withCredentials: true };
class RestService {
    constructor(http) {
        this.http = http;
    }
    GET(url) {
        return this.http.get(url, options).pipe(map((response) => {
            return response;
        }));
    }
    POST(url, data) {
        return this.http.post(url, data, options).pipe(map((response) => {
            return response;
        }));
    }
    PUT(url, data) {
        return this.http.put(url, data, options).pipe(map((response) => {
            return response;
        }));
    }
    DELETE(url, data = {}) {
        const customOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: data,
            withCredentials: true,
        };
        return this.http.delete(url, customOptions).pipe(map((response) => {
            return response;
        }));
    }
}
RestService.ɵfac = function RestService_Factory(t) { return new (t || RestService)(i0.ɵɵinject(i1.HttpClient)); };
RestService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RestService, factory: RestService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RestService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class SnackbarService {
    constructor(snackBar) {
        this.snackBar = snackBar;
    }
    display(displayMessage, snackbarPosition, pannelClass, action, duration) {
        this.snackBar.open(displayMessage, action, {
            verticalPosition: snackbarPosition,
            panelClass: pannelClass,
            duration: duration,
        });
    }
}
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return new (t || SnackbarService)(i0.ɵɵinject(i1$1.MatLegacySnackBar)); };
SnackbarService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SnackbarService, factory: SnackbarService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1$1.MatLegacySnackBar }]; }, null); })();

const DATE_MDY = (dateObj) => {
    return moment.utc(dateObj).format('MM/DD/YYYY');
};
const DATE_TIME = (dateObj) => {
    return moment(dateObj).format('MM/DD/YYYY HH:mm:ss');
};
const DATE_YMD = (dateObj) => {
    return FORMAT_DATE(dateObj, 'YYYY-MM-DD');
};
const DATE_MDY_LOCAL = (dateObj) => {
    return FORMAT_DATE(dateObj, 'MM/DD/YYYY');
};
const FORMAT_DATE = (dateObj, format) => {
    return moment(dateObj).format(format);
};
const YMD_TO_MOMENT = (dateString) => {
    return moment(dateString, 'YYYY-MM-DD');
};
const IS_EXISTING_DATE = (dateValue) => {
    return moment(dateValue, 'L').isValid();
};
const IS_LESS_THAN_CURRENT_TIMESTAMP = (expiresAt) => {
    return moment(expiresAt) < moment();
};
const CALCULATE_TRANSIT_DAYS = (pickupDate, deliveryDate) => {
    if (pickupDate != 'Unknown' && deliveryDate != 'Unknown') {
        return moment(deliveryDate).diff(moment(pickupDate), 'days');
    }
    else if (deliveryDate != null) {
        return deliveryDate;
    }
    else {
        return 1;
    }
};
const TIMESTAMP_FROM_STRING = (obj) => {
    return moment(obj).toISOString();
};
const ADD_DAYS = (obj, daysToAdd) => {
    return moment(obj).add(daysToAdd, 'days').format('MM/DD/YYYY');
};
const YESTERDAY = () => {
    return moment().subtract(1, 'days');
};
const TODAY = () => {
    return moment();
};
const TOMORROW = () => {
    return moment().add(1, 'days');
};
const AFTER_7_DAYS = () => {
    return moment().add(6, 'days');
};
const AFTER_30_DAYS = () => {
    return moment().add(29, 'days');
};
const AFTER_90_DAYS = () => {
    return moment().add(89, 'days');
};
const END_OF_MONTH_MOMENT_OBJ = () => {
    return moment().endOf('month');
};
const START_OF_NEXT_MONTH = () => {
    return moment().add(1, 'month').startOf('month');
};
const END_OF_NEXT_MONTH = () => {
    return moment().add(1, 'month').endOf('month');
};
const GET_MOMENT = () => {
    return TODAY().format('MM/DD/YYYY');
};
const START_OF_MONTH = () => {
    return moment().startOf('month').format('MM-DD-YYYY');
};
const END_OF_MONTH = () => {
    return moment().endOf('month').format('MM-DD-YYYY');
};
const DIFFERENCE_IN_DAYS = (startDate, endDate) => {
    return moment(endDate).diff(moment(startDate), 'days') + 1;
};
const IS_VALID_DATE = (dateValue, acceptedFormats) => {
    return moment(dateValue, acceptedFormats, true).isValid();
};
const GET_UTC_DATE = (localDate) => {
    let dateValue = moment(localDate).utc().format('YYYY-MM-DD HH:mm');
    return moment.utc(dateValue).format('YYYY-MM-DD');
};
const TO_UTC = (localDate) => {
    return localDate.utc();
};
const FROM_UTC = (utcDate) => {
    return moment.utc(utcDate).local();
};
const ENUMERATE_DAYS_BETWEEN_DATES = (startDate, endDate) => {
    startDate = moment(startDate);
    endDate = moment(endDate);
    let now = startDate, dates = [];
    while (now.isBefore(endDate) || now.isSame(endDate)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(1, 'days');
    }
    return dates.join(', ');
};
const GET_UNIX_TIMESTAMP = (dateobj) => {
    return moment(dateobj).unix();
};
const SUBTRACT_DAYS_FROM_TODAY = (daysToSubtract) => {
    return moment().subtract(daysToSubtract, 'days');
};
const SET_TIME_TO_START_OF_THE_DAY = (date) => {
    return moment(date).startOf('day');
};
const SET_TIME_TO_END_OF_THE_DAY = (date) => {
    return moment(date).endOf('day');
};
const DIFFERENCE_FROM_NOW = (dateInUtc, unitOfTime) => {
    return moment().diff(moment(FROM_UTC(dateInUtc)), unitOfTime);
};

const IS_NOT_EMPTY = (stringToCheck) => {
    return !!(stringToCheck != undefined &&
        stringToCheck != null &&
        (typeof stringToCheck === 'string' || stringToCheck instanceof String) &&
        stringToCheck.length > 0);
};
const IS_EMPTY = (stringToCheck) => {
    return !IS_NOT_EMPTY(stringToCheck);
};
const CAMEL_CASE = (str) => {
    if (IS_NOT_EMPTY(str)) {
        return str
            .toLowerCase()
            .split(' ')
            .filter((word) => IS_NOT_EMPTY(word))
            .map((word) => {
            return word[0].toUpperCase() + word.substr(1);
        })
            .join(' ');
    }
    return '';
};
const TITLE_CASE = (str) => {
    if (IS_NOT_EMPTY(str)) {
        return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
    }
    return str;
};
const EQUALS_IGNORE_CASE = (stringToCompare, originalString) => {
    let result = false;
    if (IS_NOT_EMPTY(stringToCompare) &&
        IS_NOT_EMPTY(originalString) &&
        stringToCompare.toLowerCase() === originalString.toLowerCase()) {
        result = true;
    }
    return result;
};

const LOCATION_PARSER = (location) => {
    let result = '';
    if (IS_NOT_EMPTY(location.city)) {
        result = location.city;
    }
    if (IS_NOT_EMPTY(location.state)) {
        result += (result.length > 0 ? ', ' : '') + location.state;
    }
    if (IS_NOT_EMPTY(location.zip) && !/\D/.test(location.zip)) {
        result += (result.length > 0 ? ', ' : '') + location.zip;
    }
    return result;
};
const POPULATE_ORIGIN = (truck, location) => {
    truck.originCity = location.city;
    truck.originState = location.state;
};
const POPULATE_DESTINATION = (truck, location) => {
    truck.destCity = location.city;
    truck.destState = location.state;
};
const HQ_LOCATION_PARSER = (city, state) => {
    let hqLocation = '';
    if (IS_NOT_EMPTY(city) || IS_NOT_EMPTY(state)) {
        if (IS_NOT_EMPTY(city) && IS_NOT_EMPTY(state)) {
            hqLocation = `${city} , ${state}`;
        }
        else if (IS_NOT_EMPTY(city)) {
            hqLocation = city;
        }
        else {
            hqLocation = state;
        }
    }
    return hqLocation;
};
const LOCATION_PARSER_WITHOUT_ZIP = (location) => {
    let result = '';
    if (IS_NOT_EMPTY(location.city)) {
        result = location.city;
    }
    if (IS_NOT_EMPTY(location.state)) {
        result += (result.length > 0 ? ', ' : '') + location.state;
    }
    return result;
};
const GET_CITY_STATE_FROM_LOCATION_STRING = (location) => {
    let result = { city: '', state: '' };
    if (IS_NOT_EMPTY(location)) {
        let stringSplit = location.split(',');
        result = {
            ...result,
            city: IS_NOT_EMPTY(stringSplit[0]) ? stringSplit[0].trim() : '',
            state: IS_NOT_EMPTY(stringSplit[1]) ? stringSplit[1].trim() : '',
        };
    }
    return result;
};

const IS_NULL_OR_UNDEFINED = (value) => {
    return value === undefined || value === null;
};
const IS_NOT_NULL_OR_UNDEFINED = (value) => {
    return value !== undefined && value !== null;
};

const GET_TIME_ZONE_LABEL = (timeZoneValue) => {
    let timeZoneLabel = null;
    for (let zone of TIME_ZONES) {
        if (zone.value === timeZoneValue) {
            timeZoneLabel = zone.label;
            break;
        }
    }
    return timeZoneLabel;
};

const TO_DOLLARS = (amountInCents) => {
    if (IS_NULL_OR_UNDEFINED(amountInCents)) {
        return amountInCents;
    }
    return Math.round(amountInCents / 100);
};
const TO_CENTS = (amountInDollars) => {
    if (IS_NULL_OR_UNDEFINED(amountInDollars)) {
        return amountInDollars;
    }
    return Math.round(amountInDollars * 100);
};

const FULL_NAME = (firstName, lastName) => {
    let fullName = '';
    if (IS_NOT_EMPTY(firstName)) {
        fullName = firstName;
    }
    if (IS_NOT_EMPTY(lastName)) {
        if (fullName.length > 0) {
            fullName += ' ';
        }
        fullName += lastName;
    }
    return fullName;
};

const GET_QUERY_PARAMS = (param) => {
    let newPayload = {
        searchTerm: '',
        isBroker: true,
        isCarrier: true,
        isShipper: true,
        isPartner: true,
        mappedCarriersOptions: true,
        plan: 0,
        isSubscriptionColumn: false,
        myAccounts: false,
        searchField: 'businessName',
        selectedUserIds: [],
        stageId: '',
        accountIds: '',
        inNetwork: false,
        withoutLanes: false,
        nextContactDate: '',
        selectedAccountIds: [],
        businessName: '',
        mappedCarriers: '',
        originCity: '',
        originState: '',
        destinationCity: '',
        destinationState: '',
        trailerType: '',
        destinationStates: '',
        needsReview: false,
        totalLanes: null,
        startDate: START_OF_MONTH(),
        endDate: END_OF_MONTH(),
        email: '',
        admin: true,
        destination: null,
        origin: null,
        pickupDate: FORMAT_DATE(new Date(), 'MM/DD/YYYY'),
        pickupDateStart: FORMAT_DATE(TODAY(), 'MM/DD/YYYY'),
        pickupDateEnd: FORMAT_DATE(TOMORROW(), 'MM/DD/YYYY'),
        carrierFilterSelected: '',
        searchDate: '',
        totalEmailCount: null,
        assignedToMe: false,
        hazmat: false,
        trailerTypes: [],
        powerUnits: null,
        notesContent: '',
        mc: '',
        dot: '',
        hasTeams: false,
        city: ''
    };
    if (IS_NOT_NULL_OR_UNDEFINED(param)) {
        if (IS_NOT_NULL_OR_UNDEFINED(param.searchTerm) && IS_NOT_EMPTY(param.searchTerm)) {
            newPayload.searchTerm = param.searchTerm;
        }
        else {
            newPayload.searchTerm = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.isBroker) && IS_NOT_EMPTY(param.isBroker)) {
            newPayload.isBroker = param.isBroker === 'true';
        }
        else {
            newPayload.isBroker = true;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.isCarrier) && IS_NOT_EMPTY(param.isCarrier)) {
            newPayload.isCarrier = param.isCarrier === 'true';
        }
        else {
            newPayload.isCarrier = true;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.isShipper) && IS_NOT_EMPTY(param.isShipper)) {
            newPayload.isShipper = param.isShipper === 'true';
        }
        else {
            newPayload.isShipper = true;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.isPartner) && IS_NOT_EMPTY(param.isPartner)) {
            newPayload.isPartner = param.isPartner === 'true';
        }
        else {
            newPayload.isPartner = true;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.mappedCarriersOptions) &&
            IS_NOT_EMPTY(param.mappedCarriersOptions)) {
            newPayload.mappedCarriersOptions = param.mappedCarriersOptions === 'true';
        }
        else {
            newPayload.mappedCarriersOptions = true;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.plan) && IS_NOT_EMPTY(param.plan)) {
            newPayload.plan = +param.plan;
        }
        else {
            newPayload.plan = 0;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.isSubscriptionColumn) &&
            IS_NOT_EMPTY(param.isSubscriptionColumn)) {
            newPayload.isSubscriptionColumn = param.isSubscriptionColumn === 'true';
        }
        else {
            newPayload.isSubscriptionColumn = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.myAccounts) && IS_NOT_EMPTY(param.myAccounts)) {
            newPayload.myAccounts = param.myAccounts === 'true';
        }
        else {
            newPayload.myAccounts = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.searchField) && IS_NOT_EMPTY(param.searchField)) {
            newPayload.searchField = param.searchField;
        }
        else {
            newPayload.searchField = 'businessName';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.selectedUserIds) && param.selectedUserIds.length > 0) {
            newPayload.selectedUserIds = JSON.parse(param.selectedUserIds);
        }
        else {
            newPayload.selectedUserIds = [];
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.stageId) && IS_NOT_EMPTY(param.stageId)) {
            newPayload.stageId = param.stageId;
        }
        else {
            newPayload.stageId = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.accountIds) && IS_NOT_EMPTY(param.accountIds)) {
            newPayload.accountIds = param.accountIds;
        }
        else {
            newPayload.accountIds = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.inNetwork) && IS_NOT_EMPTY(param.inNetwork)) {
            newPayload.inNetwork = param.inNetwork === 'true';
        }
        else {
            newPayload.inNetwork = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.withoutLanes) && IS_NOT_EMPTY(param.withoutLanes)) {
            newPayload.withoutLanes = param.withoutLanes === 'true';
        }
        else {
            newPayload.withoutLanes = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.nextContactDate) && IS_NOT_EMPTY(param.nextContactDate)) {
            newPayload.nextContactDate = JSON.parse(param.nextContactDate);
        }
        else {
            newPayload.nextContactDate = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.selectedAccountIds) && param.selectedAccountIds.length > 0) {
            newPayload.selectedAccountIds = JSON.parse(param.selectedAccountIds);
        }
        else {
            newPayload.selectedAccountIds = [];
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.businessName) && IS_NOT_EMPTY(param.businessName)) {
            newPayload.businessName = param.businessName;
        }
        else {
            newPayload.businessName = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.mappedCarriers) && IS_NOT_EMPTY(param.mappedCarriers)) {
            newPayload.mappedCarriers = param.mappedCarriers === 'true';
        }
        else {
            newPayload.mappedCarriers = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.originCity) && IS_NOT_EMPTY(param.originCity)) {
            newPayload.originCity = param.originCity;
        }
        else {
            newPayload.originCity = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.originState) && IS_NOT_EMPTY(param.originState)) {
            newPayload.originState = param.originState;
        }
        else {
            newPayload.originState = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.destinationCity) && IS_NOT_EMPTY(param.destinationCity)) {
            newPayload.destinationCity = param.destinationCity;
        }
        else {
            newPayload.destinationCity = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.destinationState) && IS_NOT_EMPTY(param.destinationState)) {
            newPayload.destinationState = param.destinationState;
        }
        else {
            newPayload.destinationState = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.trailerType) && IS_NOT_EMPTY(param.trailerType)) {
            newPayload.trailerType = param.trailerType;
        }
        else {
            newPayload.trailerType = 'VAN';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.destinationStates) &&
            IS_NOT_EMPTY(param.destinationStates)) {
            newPayload.destinationStates = param.destinationStates;
        }
        else {
            newPayload.destinationStates = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.needsReview)) {
            newPayload.needsReview = param.needsReview === 'true';
        }
        else {
            newPayload.needsReview = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.totalLanes) && IS_NOT_EMPTY(param.totalLanes)) {
            newPayload.totalLanes = +param.totalLanes;
        }
        else {
            newPayload.totalLanes = null;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.startDate) && IS_NOT_EMPTY(param.startDate)) {
            newPayload.startDate = param.startDate;
        }
        else {
            newPayload.startDate = START_OF_MONTH();
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.endDate) && IS_NOT_EMPTY(param.endDate)) {
            newPayload.endDate = param.endDate;
        }
        else {
            newPayload.endDate = END_OF_MONTH();
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.email) && IS_NOT_EMPTY(param.email)) {
            newPayload.email = param.email;
        }
        else {
            newPayload.email = null;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.destination) && IS_NOT_EMPTY(param.destination)) {
            newPayload.destination = JSON.parse(param.destination);
        }
        else {
            newPayload.destination = null;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.origin) && IS_NOT_EMPTY(param.origin)) {
            newPayload.origin = JSON.parse(param.origin);
        }
        else {
            newPayload.origin = null;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.pickupDate) && IS_NOT_EMPTY(param.pickupDate)) {
            newPayload.pickupDate = param.pickupDate;
        }
        else {
            newPayload.pickupDate = FORMAT_DATE(new Date(), 'MM/DD/YYYY');
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.admin)) {
            newPayload.admin = param.admin === 'true';
        }
        else {
            newPayload.admin = true;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.pickupDateStart) && IS_NOT_EMPTY(param.pickupDateStart)) {
            newPayload.pickupDateStart = param.pickupDateStart;
        }
        else {
            newPayload.pickupDateStart = DATE_YMD(TODAY());
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.pickupDateEnd) && IS_NOT_EMPTY(param.pickupDateEnd)) {
            newPayload.pickupDateEnd = param.pickupDateEnd;
        }
        else {
            newPayload.pickupDateEnd = DATE_YMD(TOMORROW());
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.destinationStates) &&
            IS_NOT_EMPTY(param.destinationStates)) {
            newPayload.destinationStates = param.destinationStates;
        }
        else {
            newPayload.destinationStates = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.destinationStates) &&
            IS_NOT_EMPTY(param.destinationStates)) {
            newPayload.destinationStates = param.destinationStates;
        }
        else {
            newPayload.destinationStates = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.searchDate) && IS_NOT_EMPTY(param.searchDate)) {
            newPayload.searchDate = param.searchDate;
        }
        else {
            newPayload.searchDate = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.carrierFilterSelected) && IS_NOT_EMPTY(param.carrierFilterSelected)) {
            newPayload.carrierFilterSelected = param.carrierFilterSelected;
        }
        else {
            newPayload.carrierFilterSelected = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.totalEmailCount) && IS_NOT_EMPTY(param.totalEmailCount)) {
            newPayload.totalEmailCount = +param.totalEmailCount;
        }
        else {
            newPayload.carrierFilterSelected = null;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.assignedToMe)) {
            newPayload.assignedToMe = param.assignedToMe === 'true';
        }
        else {
            newPayload.assignedToMe = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.hasTeams)) {
            newPayload.hasTeams = param.hasTeams === 'true';
        }
        else {
            newPayload.hasTeams = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.hazmat)) {
            newPayload.hazmat = param.hazmat === 'true';
        }
        else {
            newPayload.hazmat = false;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.mc) && IS_NOT_EMPTY(param.mc)) {
            newPayload.mc = param.mc;
        }
        else {
            newPayload.mc = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.dot) && IS_NOT_EMPTY(param.dot)) {
            newPayload.dot = param.dot;
        }
        else {
            newPayload.dot = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.notesContent) && IS_NOT_EMPTY(param.notesContent)) {
            newPayload.notesContent = param.notesContent;
        }
        else {
            newPayload.notesContent = '';
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.trailerTypes) && IS_NOT_EMPTY(param.trailerTypes)) {
            newPayload.trailerTypes = param.trailerTypes.split(',');
        }
        else {
            newPayload.trailerTypes = [];
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.powerUnits) && IS_NOT_EMPTY(param.powerUnits)) {
            newPayload.powerUnits = +param.powerUnits;
        }
        else {
            newPayload.powerUnits = null;
        }
        if (IS_NOT_NULL_OR_UNDEFINED(param.city) && IS_NOT_EMPTY(param.city)) {
            newPayload.city = param.city;
        }
        else {
            newPayload.city = '';
        }
        return newPayload;
    }
};

const ACCOUNT_DETAILS_TYPE = (accountDetails = null) => {
    let result = {};
    if (accountDetails != null) {
        result.APIToken = accountDetails.apiToken;
        result.createdAt = DATE_MDY(accountDetails.accountCreatedAt);
        result.daysToPay = accountDetails.daysToPay || null;
        result.dot = accountDetails.accountDot || '';
        result.fromEmail = accountDetails.accountFromEmail;
        result.accountId = accountDetails.accountId;
        result.mc = accountDetails.accountMc;
        result.name = accountDetails.accountName;
        result.numberOfUsers = accountDetails.users || 0;
        if (accountDetails.subscription != null && accountDetails.subscription != undefined) {
            result.plan = accountDetails.subscription.plan.displayName;
            result.planPrice = accountDetails.subscription.plan.price;
            result.subscriptionId = accountDetails.subscription.id;
            result.subscriptionCreatedAt = DATE_MDY(accountDetails.subscription.createdAt);
            result.nextPaymentDate = IS_NOT_NULL_OR_UNDEFINED(accountDetails.subscription.nextPaymentDate)
                ? DATE_MDY(accountDetails.subscription.nextPaymentDate)
                : 'N/A';
            result.lastPaymentDate = IS_NOT_NULL_OR_UNDEFINED(accountDetails.subscription.lastPaymentDate)
                ? DATE_MDY(accountDetails.subscription.lastPaymentDate)
                : 'N/A';
            result.freeTrial = IS_NOT_NULL_OR_UNDEFINED(accountDetails.subscription.freeTrial)
                ? DATE_MDY(accountDetails.subscription.freeTrial)
                : 'N/A';
            result.creditCardPayment =
                IS_NOT_NULL_OR_UNDEFINED(accountDetails.subscription.creditCardPayment) &&
                    accountDetails.subscription.creditCardPayment;
        }
        else {
            result.plan = '';
            result.subscriptionId = null;
            result.creditCardPayment = false;
        }
        result.totalTruckSearches = accountDetails.truckSearches || 0;
        result.systemName = accountDetails.systemName || '';
        result.accountType = accountDetails.accountType;
        if (!accountDetails?.subscription?.plan?.seatPricing) {
            result.minimumSeats = `N/A`;
        }
        else {
            result.minimumSeats = accountDetails.minimumSeats;
        }
        result.loadsPerMonth = accountDetails.loadsPerMonth || 0;
        result.annualRevenue = accountDetails.annualRevenue || 0;
        if (IS_NOT_NULL_OR_UNDEFINED(accountDetails.termsAgreedAt)) {
            result.termsAgreedAt = DATE_TIME(accountDetails.termsAgreedAt);
        }
        result.timeZone = accountDetails.timeZone;
    }
    return result;
};

const ADMIN_ACCOUNT_DETAILS_LIST_TABLE = (usersList = []) => {
    let results = [];
    if (usersList.length > 0) {
        usersList.map((user) => {
            let row = {};
            row.action = '';
            row.createdAt = user?.createdAt ? DATE_MDY(user.createdAt) : null;
            row.email = user.email;
            row.fromEmail = user.fromEmail;
            row.firstName = user.firstName;
            row.lastLogin = user?.lastLogin ? DATE_MDY(user.lastLogin) : null;
            row.lastName = user.lastName;
            row.phoneNumber = user.phoneNumber;
            row.userId = user.id;
            row.userType = user.userType;
            row.role = user.role;
            row.accountStatus = user.accountStatus;
            row.addToStripe = user.addToStripe;
            row.isEmailSender = user.isEmailSender;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_ACCOUNTS_LIST_TABLE = (carrierList = []) => {
    let results = [];
    if (carrierList.length > 0) {
        carrierList.map((account) => {
            let row = {};
            row.accountId = account.id;
            row.accountType = account.accountType;
            row.business_name = account.businessName;
            row.dot = account.dot || '--';
            row.mc = account.mc || '--';
            if (account.subscription !== undefined && account.subscription != null) {
                row.last_payment_date = account.subscription.lastPaymentDate;
                row.next_payment_date = account.subscription.nextPaymentDate;
                row.plan = account.subscription.plan.displayName;
                row.status = account.subscription.status;
                row.subscriptionId = account.subscription.id;
                row.subscription = account.subscription;
            }
            else {
                row.last_payment_date = null;
                row.next_payment_date = null;
                row.plan = 'Free';
                row.status = 'INACTIVE';
                row.subscriptionId = null;
            }
            results.push(row);
        });
    }
    return results;
};

const QUICK_SEARCH_ACCOUNTS_TABLE = (accounts) => {
    const result = [];
    accounts.forEach((account) => {
        const searchResult = {};
        searchResult.id = account.id;
        searchResult.businessName = account.businessName;
        searchResult.mc = account.mc;
        searchResult.dot = account.dot;
        if (IS_NOT_NULL_OR_UNDEFINED(account.users)) {
            const user = account.users[0];
            if (IS_NOT_NULL_OR_UNDEFINED(user)) {
                searchResult.contactName = FULL_NAME(user.firstName, user.lastName);
                searchResult.contactPhone = user.phoneNumber;
                searchResult.contactEmail = user.email;
            }
        }
        result.push(searchResult);
    });
    return result;
};

const ACCOUNT_DETAIL_FIELDS = {
    ID: 'ID:',
    DOT: 'Dot:',
    PLAN: 'Plan:',
    NAME: 'Name:',
    MC: 'MC:',
    CREATED_AT: 'Created at:',
    FROM_EMAIL: 'From Email:',
    DAYS_TO_PAY: 'Days To Pay:',
    SYSTEM_NAME: 'System Name:',
    API_TOKEN: 'API Token:',
};

const ACCOUNT_SETTINGS_FIELD = {
    SEARCH_TRUCK_PICKUP_DATERANGE: 'Search Truck Pickup Date Range:',
    SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT: 'Search Truck Origin Deadhead Limit:',
    SEARCH_TRUCK_RESULTS_COUNT: 'Search Truck Results Count:',
    SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT: 'Search Truck Destination Deadhead Limit:',
    DEMO_ACCOUNT: 'Demo Account:',
    BCC_USER_OFFERS: 'Bcc User Offers:',
    SEARCHABLE_TRAILER_TYPES: 'Searchable Trailer Types:',
    PICKUP_APPOINTMENT_REQUIRED: 'Pick up Appointment Required:',
    DECLARED_VALUE_REQUIRED: 'Declared Value Required:',
    DELIVERY_APPOINTMENT_REQUIRED: 'Delivery Appointment Required:',
    SEND_RATE_CON: 'Send Rate Con:',
    IS_FEEDBACK_ENABLED: 'Is Feedback Enabled:',
    TRUCK_SEARCH_ENABLED: 'Truck Search Enabled:',
    FREQUENCY_ENABLED: 'Frequency Enabled',
    WEIGHT_REQUIRED: 'Weight Required',
    TARGET_MARGIN: 'Target Margin',
    PROJECT_PROBABILITY: 'Project Probability',
    DEFAULT_TO_MY_PROJECTS: 'Default To My Projects Page',
    ANNUAL_VOLUME: 'Display Annual Volume',
    SCORECARDS: 'Scorecards',
    CUSTOMERS: 'Customers Page',
    CARRIER_RATES: 'Carrier Rates',
    POST_LOAD: 'Post Load',
    VOLUME_REQUIRED: 'Volume Required',
    PROJECTS_BOARD: 'Projects Board',
    USER_ENABLED_PROJECT_BOARD: 'User Enabled Project Board',
    MCLEOD_INTEGRATION: 'Mcleod Integration',
    HAZMAT: 'Hazmat',
    STRONG_LANES: 'Strong Lanes',
    TEAMS_CAPACITY: 'Teams Capacity',
    BOOKING_ASSISTANT: 'Booking Assistant Enabled',
    GET_OPTION_VISIBLE: 'Get Option Visible',
    CUSTOMIZABLE_EMAILS: 'Customizable Emails',
    EMAIL_ROUTING: 'Email Routing',
    CONFIDENCE_SCORE: 'Confidence Score',
    SEND_LOADS_WITH_NO_RATE: 'Send Loads with no Rate',
    RATE_RECENCY_LIMIT: 'Rate Recency Limit',
    PICKUP_DATE_THRESHOLD: 'Pickup Date Threshold',
    PARTIAL_LOAD_ENABLED: 'Partial Load Enabled',
    AMAZON_FREIGHT: 'Amazon Freight',
    ROLE_BASED_CUSTOMER_DATA_ACCESS: 'Role Based Customer Data Access',
    BA_PERFORMANCE_METRICS_ENABLED: 'BA Performance Metrics Enabled',
    PROJECT_GROUPS_ENABLED: 'Waterfall Projects',
};

const ACTIVITY_TYPES = {
    QUOTE_CREATED: 'QUOTE_CREATED',
    CARRIER_INVITED: 'CARRIER_INVITED',
    CARRIER_ACCEPTED: 'CARRIER_ACCEPTED',
    CARRIER_COUNTERED: 'CARRIER_COUNTERED',
    CARRIER_DECLINED: 'CARRIER_DECLINED',
    BOOKING_CREATED: 'BOOKING_CREATED',
    BOOKING_SIGNED: 'BOOKING_SIGNED',
    ALL_BIDS_SENT: 'ALL_BIDS_SENT',
    ASCEND_BID_CREATED: 'ASCEND_BID_CREATED',
    BOOKING_CONFIRMATION: 'BOOKING_CONFIRMATION',
    BROKER_COUNTERED: 'BROKER_COUNTERED',
    NOTIFICATIONS_SCHEDULED: 'NOTIFICATIONS_SCHEDULED',
};
const ACTIVITY_TYPE_MESSAGE = {
    QUOTE_CREATED: 'Quote Created',
    CARRIER_INVITED: 'Offer sent to ',
    CARRIER_ACCEPTED: 'Offer accepted by ',
    CARRIER_COUNTERED: 'Counter offer received from ',
    CARRIER_DECLINED: 'Offer declined by ',
    BOOKING_CREATED: 'Rate confirmation generated for ',
    BOOKING_SIGNED: 'Rate confirmation signed by ',
    ALL_BIDS_SENT: 'All offers sent to carriers',
    ASCEND_BID_CREATED: 'Offer created from Ascend. Offer received from ',
    BOOKING_CONFIRMATION: ' Accepted after Booking Confirmation is submitted',
    NOTIFICATIONS_SCHEDULED: 'All notification groups scheduled',
};

const MAP_ACTIVITY_TYPE = (activity) => {
    switch (activity.activityType.toLowerCase()) {
        case ACTIVITY_TYPES.QUOTE_CREATED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.QUOTE_CREATED;
        case ACTIVITY_TYPES.CARRIER_INVITED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.CARRIER_INVITED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.CARRIER_ACCEPTED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.CARRIER_ACCEPTED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.CARRIER_COUNTERED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.CARRIER_COUNTERED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.CARRIER_DECLINED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.CARRIER_DECLINED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.BOOKING_CREATED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.BOOKING_CREATED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.BOOKING_SIGNED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.BOOKING_SIGNED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.ALL_BIDS_SENT.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.ALL_BIDS_SENT;
        case ACTIVITY_TYPES.ASCEND_BID_CREATED.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.ASCEND_BID_CREATED + activity.carrierBusinessName || 'Carrier';
        case ACTIVITY_TYPES.BOOKING_CONFIRMATION.toLowerCase():
            return ACTIVITY_TYPE_MESSAGE.BOOKING_CONFIRMATION;
        case ACTIVITY_TYPES.BROKER_COUNTERED.toLowerCase():
            return activity.message.charAt(0).toUpperCase() + activity.message.slice(1);
        default:
            return activity.message;
    }
};

const ACTIVITY_LIST = (activityDTO = []) => {
    let results = [];
    if (activityDTO.length > 0) {
        activityDTO.map((activity) => {
            let row = {};
            row.activityType = activity.activityType;
            row.amount = activity.amount;
            row.created = activity.created;
            row.message = MAP_ACTIVITY_TYPE(activity);
            results.push(row);
        });
    }
    return results;
};

var BID_STATUS_UUID;
(function (BID_STATUS_UUID) {
    BID_STATUS_UUID["9a0dc3e6-b451-4cf0-92e5-29d6e3695102"] = "Accepted";
    BID_STATUS_UUID["88a8ba81-838a-43d3-86c5-d6d77240da71"] = "Cancelled";
    BID_STATUS_UUID["d2261f74-2f48-4c01-a426-748ecb950912"] = "Countered";
    BID_STATUS_UUID["269e4734-6ade-44a3-952b-6e619d0ac14b"] = "Declined";
    BID_STATUS_UUID["a030ad02-2903-48f5-83ec-d74208d44c35"] = "Expired";
    BID_STATUS_UUID["47102931-c5cd-4732-bb75-00e73c702e9e"] = "Invited";
    BID_STATUS_UUID["225d67d1-a733-45f6-8425-a6973bc1c0ac"] = "New";
    BID_STATUS_UUID["cb556a7e-8a46-4d08-850a-f2fa44e66673"] = "Viewed";
    BID_STATUS_UUID["5903a778-52bc-42cc-8e66-5dab8a8821c4"] = "Selected";
    BID_STATUS_UUID["f9559662-da71-11ec-9d64-0242ac120002"] = "Responded";
    BID_STATUS_UUID["8914abf0-e508-4825-9c8c-4961db86dca5"] = "Scheduled";
})(BID_STATUS_UUID || (BID_STATUS_UUID = {}));
const BID_DISPLAY_STATUS_CONSTANTS = {
    NEW: 'New',
    INVITED: 'Invited',
    ACCEPTED: 'Accepted',
    DECLINED: 'Declined',
    COUNTER_SENT: 'Counter Sent',
    COUNTER_RECEIVED: 'Counter Received',
    VIEWED: 'Viewed',
    CANCELLED: 'Cancelled',
    CONFIRMED: 'Confirmed',
    DRAFT: 'Draft',
    SIGNED: 'Signed',
    EXPIRED: 'Expired',
    RATE_CON_SENT: 'RateCon Sent',
    SELECTED: 'Selected',
    RESPONSE_RECEIVED: 'Response Recieved',
    ASSIGNED: 'Assigned',
    SCHEDULED: 'Scheduled',
    DAILY_LIMIT_REACHED: 'Daily Limit Reached',
};
var BID_STATUS_STRING;
(function (BID_STATUS_STRING) {
    BID_STATUS_STRING["NEW"] = "NEW";
    BID_STATUS_STRING["INVITED"] = "INVITED";
    BID_STATUS_STRING["ACCEPTED"] = "ACCEPTED";
    BID_STATUS_STRING["DECLINED"] = "DECLINED";
    BID_STATUS_STRING["COUNTERED"] = "COUNTERED";
    BID_STATUS_STRING["DRAFT"] = "DRAFT";
    BID_STATUS_STRING["SIGNED"] = "SIGNED";
    BID_STATUS_STRING["VIEWED"] = "VIEWED";
    BID_STATUS_STRING["CANCELLED"] = "CANCELLED";
    BID_STATUS_STRING["EXPIRED"] = "EXPIRED";
    BID_STATUS_STRING["SELECTED"] = "SELECTED";
    BID_STATUS_STRING["RESPONSE_RECEIVED"] = "RESPONSE_RECEIVED";
    BID_STATUS_STRING["ASSIGNED"] = "ASSIGNED";
    BID_STATUS_STRING["SCHEDULED"] = "SCHEDULED";
    BID_STATUS_STRING["DAILY_LIMIT_REACHED"] = "DAILY_LIMIT_REACHED";
})(BID_STATUS_STRING || (BID_STATUS_STRING = {}));
var BID_SOURCE_TYPE;
(function (BID_SOURCE_TYPE) {
    BID_SOURCE_TYPE["CARRIER"] = "CARRIER";
    BID_SOURCE_TYPE["CUSTOMER"] = "CUSTOMER";
})(BID_SOURCE_TYPE || (BID_SOURCE_TYPE = {}));

const BidViewTemplate = {
    origin: 'Origin:',
    destination: 'Destination:',
    trailerType: 'Trailer Type:',
    weight: 'Weight (lbs.):',
    approximateMiles: 'Approximate Miles:',
    commodity: 'Commodity:',
    expectedPickup: 'Expected Pickup:',
    expectedDelivery: 'Expected Delivery:',
    c4LoadNumber: 'C4 Load Number:',
    ourClient: 'Our Client:',
    specialInstructions: 'Special Instructions:',
    offeredPrice: 'Offered Price:',
};

const GET_BID_STATUS_CLASS = (status) => {
    switch (status.toLowerCase()) {
        case BID_STATUS_STRING.ACCEPTED.toLowerCase():
        case BID_STATUS_STRING.SIGNED.toLowerCase():
        case BID_STATUS_STRING.DRAFT.toLowerCase():
            return 'accepted-chip';
        case BID_STATUS_STRING.SELECTED.toLowerCase():
        case BID_STATUS_STRING.ASSIGNED.toLowerCase():
            return 'selected-chip';
        case BID_STATUS_STRING.CANCELLED.toLowerCase():
            return 'label-warning';
        case BID_STATUS_STRING.COUNTERED.toLowerCase():
            return 'countered-chip';
        case BID_STATUS_STRING.DECLINED.toLowerCase():
            return 'declined-chip';
        case BID_STATUS_STRING.EXPIRED.toLowerCase():
            return 'label-primary';
        case BID_STATUS_STRING.INVITED.toLowerCase():
        case BID_STATUS_STRING.NEW.toLowerCase():
            return 'invited-chip';
        case BID_STATUS_STRING.RESPONSE_RECEIVED.toLowerCase():
        case BID_STATUS_STRING.VIEWED.toLowerCase():
        case BID_STATUS_STRING.SCHEDULED.toLowerCase():
            return 'viewed-chip';
    }
};

const GET_BID_STATUS_FROM_STRING = (status, sourceType, bid = null) => {
    switch (status.toLowerCase()) {
        case BID_STATUS_STRING.INVITED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.INVITED;
        case BID_STATUS_STRING.ACCEPTED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.ACCEPTED;
        case BID_STATUS_STRING.DECLINED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.DECLINED;
        case BID_STATUS_STRING.COUNTERED.toLowerCase():
            return sourceType == BID_SOURCE_TYPE.CARRIER
                ? BID_DISPLAY_STATUS_CONSTANTS.COUNTER_RECEIVED
                : BID_DISPLAY_STATUS_CONSTANTS.COUNTER_SENT;
        case BID_STATUS_STRING.DRAFT.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.RATE_CON_SENT;
        case BID_STATUS_STRING.SIGNED.toLowerCase():
            if (bid?.isEligibleForBookNow) {
                return BID_DISPLAY_STATUS_CONSTANTS.ASSIGNED;
            }
            return BID_DISPLAY_STATUS_CONSTANTS.SIGNED;
        case BID_STATUS_STRING.VIEWED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.VIEWED;
        case BID_STATUS_STRING.CANCELLED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.CANCELLED;
        case BID_STATUS_STRING.NEW.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.NEW;
        case BID_STATUS_STRING.SELECTED.toLowerCase():
            if (bid?.isEligibleForBookNow) {
                return BID_DISPLAY_STATUS_CONSTANTS.ASSIGNED;
            }
            return BID_DISPLAY_STATUS_CONSTANTS.SELECTED;
        case BID_STATUS_STRING.RESPONSE_RECEIVED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.RESPONSE_RECEIVED;
        case BID_STATUS_STRING.SCHEDULED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.SCHEDULED;
        case BID_STATUS_STRING.DAILY_LIMIT_REACHED.toLowerCase():
            return BID_DISPLAY_STATUS_CONSTANTS.DAILY_LIMIT_REACHED;
        default:
            return status;
    }
};

const BID_DETAILS_TABLE = (bidList = [], SEND_RATE_CON) => {
    let results = [];
    if (bidList.length > 0) {
        bidList.map((bid) => {
            let row = {};
            row.allInPrice = bid.allInPrice;
            row.bidStatus = bid.status;
            row.bidId = bid.id;
            row.businessName = bid.carrierBusinessName;
            row.customerCarrier = bid.customerCarrier;
            row.oldCarrierId = bid.oldCarrierId || null;
            row.carrierId = bid.carrierId;
            row.pickupDate = new Date(DATE_MDY(bid.pickupDate));
            row.transitDays = bid.estimatedDays;
            row.truckLocation =
                bid.truckOriginCity != undefined && bid.truckOriginState != undefined
                    ? bid.truckOriginCity + ', ' + bid.truckOriginState
                    : '';
            row.carrierHQ =
                (bid.carrierCity != undefined && bid.carrierCity != null ? bid.carrierCity + ', ' : '') +
                    (bid.carrierState != undefined && bid.carrierState != null ? bid.carrierState : '');
            if (bid.bidHistories.length > 0) {
                // get latest bid history to find who countered bid last
                const bidHistories = bid.bidHistories.sort((a, b) => (b.created > a.created ? 1 : -1));
                row.sourceType = bidHistories[0].sourceType;
            }
            else {
                row.sourceType = BID_SOURCE_TYPE.CUSTOMER;
            }
            row.statusDisplay = GET_BID_STATUS_FROM_STRING(row.bidStatus, row.sourceType, bid);
            row.statusClass = GET_BID_STATUS_CLASS(row.bidStatus);
            if (bid?.isEligibleForBookNow && bid.status == BID_STATUS_STRING.SIGNED) {
                row.statusDisplay = BID_DISPLAY_STATUS_CONSTANTS.ASSIGNED;
            }
            else if (bid.status == BID_STATUS_STRING.SIGNED && !SEND_RATE_CON) {
                row.statusDisplay = BID_DISPLAY_STATUS_CONSTANTS.SELECTED;
            }
            row.lastModified = bid.lastModified;
            row.deliveryDate = new Date(DATE_MDY(bid.deliveryDate));
            row.carrierLastFmcsaUpdate = bid.carrierLastFmcsaUpdate || null;
            row.drivers = bid.drivers;
            row.powerUnits = bid.powerUnits;
            row.carrierContactPhone = bid.carrierContactPhone;
            row.mc = bid.mc;
            row.dot = bid.dot;
            row.porusTruckId = bid.porusTruckId || null;
            row.truckLaneId = bid.truckLaneId || null;
            row.declineReason = bid.declineReason;
            row.isEligibleForBookNow = bid.isEligibleForBookNow;
            row.lastView = bid.lastView;
            row.lastReply = bid.lastReply;
            results.push(row);
        });
    }
    return results;
};

const CARRIER_BID_TABLE = (carrierBids = []) => {
    let results = [];
    if (carrierBids.length > 0) {
        carrierBids.map((carrierBid) => {
            let row = {};
            row.bidId = carrierBid.bidId;
            row.referenceNumber = carrierBid.referenceNumber;
            row.origin = HQ_LOCATION_PARSER(carrierBid.originCity, carrierBid.originState);
            row.destination = HQ_LOCATION_PARSER(carrierBid.destinationCity, carrierBid.destinationState);
            row.equipment = carrierBid.equipment;
            row.pickupDate = DATE_YMD(FROM_UTC(carrierBid.pickupDate));
            row.deliveryDate = DATE_YMD(FROM_UTC(carrierBid.deliveryDate));
            row.bidStatus = BID_STATUS_UUID[carrierBid.bidStatus];
            row.offeredPrice = TO_DOLLARS(carrierBid.offeredPrice);
            row.bidAmount = TO_DOLLARS(carrierBid.bidAmount);
            const customer = carrierBid.customer;
            if (IS_NOT_NULL_OR_UNDEFINED(customer)) {
                row.customerName = FULL_NAME(customer.firstName, customer.lastName);
                row.customerEmail = customer.email;
                row.customerPhone = customer.phoneNumber;
                row.brokerBusinessName = customer.businessName;
            }
            row.bidHistoryList = carrierBid.bidHistoryList;
            results.push(row);
        });
    }
    return results;
};

const CARRIER_BID_ACTIVITY = (carrierBidResponse) => {
    const { bidHistoryList, customer, bidStatus, quoteLastModified, bidAmount, winningBidId, bidId } = carrierBidResponse;
    const activityList = [];
    if (IS_NOT_NULL_OR_UNDEFINED(bidHistoryList)) {
        let firstBidHistory = null;
        bidHistoryList.forEach((bidHistory, index) => {
            const activity = {};
            activity.timestamp = FORMAT_DATE(bidHistory.created, 'MM/DD HH:mm');
            activity.pickupDate = DATE_MDY(bidHistory.pickupDate);
            activity.deliveryDate = DATE_MDY(bidHistory.deliveryDate);
            activity.amount = TO_DOLLARS(bidHistory.amount);
            if (index == 0) {
                activity.message = `${customer.businessName} created Quote`;
                firstBidHistory = bidHistory;
            }
            else if (index == bidHistoryList.length - 1 &&
                bidHistory.sourceType == 'CUSTOMER' &&
                BID_STATUS_UUID[bidStatus] == BID_DISPLAY_STATUS_CONSTANTS.CANCELLED) {
                activity.message = `${customer.businessName} cancelled Quote`;
                activity.pickupDate = null;
                activity.deliveryDate = null;
            }
            else {
                if (bidHistory.sourceType == 'CUSTOMER') {
                    if (isBidUpdated(firstBidHistory, bidHistory)) {
                        activity.message = `${customer.businessName}' updated offer`;
                    }
                    else {
                        activity.message = `${customer.businessName}'s offer`;
                    }
                }
                else {
                    if (isBidUpdated(firstBidHistory, bidHistory)) {
                        activity.message = 'You updated offer';
                    }
                    else {
                        activity.message = 'You accepted offer';
                    }
                }
            }
            activityList.push(activity);
        });
    }
    if (BID_STATUS_UUID[bidStatus] == BID_DISPLAY_STATUS_CONSTANTS.SELECTED &&
        bidId == winningBidId) {
        activityList.push({
            timestamp: FORMAT_DATE(quoteLastModified, 'MM/DD HH:mm'),
            amount: null,
            pickupDate: null,
            deliveryDate: null,
            message: 'Your offer was selected',
        });
    }
    return activityList;
};
const isBidUpdated = (firstBidHistory, currentBidHistory) => {
    let result = false;
    if (firstBidHistory.pickupDate != currentBidHistory.pickupDate ||
        firstBidHistory.deliveryDate != currentBidHistory.deliveryDate ||
        firstBidHistory.amount != currentBidHistory.amount) {
        result = true;
    }
    return result;
};

const BulkCapacityMatchJobStatus = {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    NEW: 'NEW',
    NOTIFICATION_PENDING: 'NOTIFICATION_PENDING',
    PROCESSED: 'PROCESSED',
    PROCESSING: 'PROCESSING',
    SCHEDULED: 'SCHEDULED',
    STAGED: 'STAGED',
};

const BULK_CAPACITY_MATCH_JOB_TABLE = (bulkCapacityMatchJobsList = [], usersList = []) => {
    let results = [];
    if (bulkCapacityMatchJobsList.length > 0) {
        bulkCapacityMatchJobsList.map((bulkCapacityMatchJob) => {
            let row = {};
            row.s3FileLocation = bulkCapacityMatchJob.s3FileLocation;
            row.jobStatus = bulkCapacityMatchJob.jobStatus;
            row.rowDescription = [];
            if (bulkCapacityMatchJob?.jobTasks?.length) {
                bulkCapacityMatchJob.jobTasks?.map((job) => {
                    let rowDescription = {};
                    rowDescription.created = job.created;
                    rowDescription.s3FileLocation = bulkCapacityMatchJob.s3FileLocation;
                    rowDescription.taskStatus = job.taskStatus;
                    row.rowDescription.push(rowDescription);
                });
                row.tasksCompleted = bulkCapacityMatchJob.jobTasks?.filter((job) => {
                    return job.taskStatus == 'COMPLETED';
                }).length;
            }
            row.created = bulkCapacityMatchJob.created;
            if (bulkCapacityMatchJob.userId) {
                row.userId = bulkCapacityMatchJob.userId;
                const user = usersList?.find((user) => user.userId == bulkCapacityMatchJob.userId);
                if (user) {
                    row.userName = user?.name;
                }
            }
            if (bulkCapacityMatchJob.stats) {
                row.tasksInserted =
                    bulkCapacityMatchJob.stats[bulkCapacityMatchJob.id][BulkCapacityMatchJobStatus.COMPLETED] || 0;
                row.tasksFailed =
                    bulkCapacityMatchJob.stats[bulkCapacityMatchJob.id][BulkCapacityMatchJobStatus.FAILED] ||
                        0;
                row.totalTasks = row.tasksParsed =
                    bulkCapacityMatchJob.stats[bulkCapacityMatchJob.id]['total'] || 0;
            }
            else {
                row.tasksInserted = row.totalTasks = row.tasksFailed = 0;
            }
            row.lastModified = bulkCapacityMatchJob.lastModified;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_CARRIER_LIST_TABLE = (carrierList = []) => {
    let results = [];
    if (carrierList.length > 0) {
        carrierList.map((carrier) => {
            let row = {};
            row.business_name = carrier.carrierDTOResponse.businessName || '';
            row.carrierId = carrier.carrierDTOResponse.id;
            row.oldCarrierId = carrier.carrierDTOResponse.oldCarrierId || null;
            row.dot = carrier.carrierDTOResponse.dot || '';
            row.last_capacity_email_received_at =
                carrier.carrierDTOResponse.lastCapacityEmailReplySentAt || null;
            row.mc = carrier.carrierDTOResponse.mc || '';
            row.contactsCount = carrier.contactsCount;
            row.doingBusinessAs = carrier.carrierDTOResponse.doingBusinessAs;
            row.inNetwork = carrier.carrierDTOResponse.inNetwork;
            row.active = carrier.carrierDTOResponse.active;
            row.laneCount = carrier.carrierDTOResponse.laneCount;
            row.accountId = carrier.carrierDTOResponse.accountId;
            row.stageId = carrier.carrierDTOResponse.stageId;
            row.carrierRecruiterLastContacted = carrier?.carrierDTOResponse?.carrierRecruiterLastContacted
                ? DATE_MDY(carrier.carrierDTOResponse.carrierRecruiterLastContacted)
                : '';
            row.carrierRecruiterNextContactDate = carrier?.carrierDTOResponse
                ?.carrierRecruiterNextContactDate
                ? DATE_MDY(carrier.carrierDTOResponse.carrierRecruiterNextContactDate)
                : '';
            row.carrierRecruiterContactedCount =
                carrier.carrierDTOResponse.carrierRecruiterContactedCount;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_LANES_CARRIERS_TABLE = (carrierList = []) => {
    let results = [];
    if (carrierList.length > 0) {
        carrierList.map((truckLaneCarrierMatch) => {
            let row = {};
            const carrier = truckLaneCarrierMatch.carrier;
            row.business_name = carrier.businessName;
            row.carrierId = carrier.id;
            row.oldCarrierId = carrier.oldCarrierId;
            row.dot = carrier.dot;
            row.email = carrier.emailAddress;
            row.mc = carrier.mc;
            row.reviewed = !truckLaneCarrierMatch.toBeReviewed;
            results.push(row);
        });
    }
    return results;
};

const GET_CARRIER_BUSINESS_NAME = (businessName, doingBusinessAs) => {
    return IS_NOT_EMPTY(doingBusinessAs) ? doingBusinessAs : businessName;
};

const CARRIER_LIST_TABLE = (carrierList = [], accountId, userCarrierMaps, usersList) => {
    let results = [];
    if (carrierList.length > 0) {
        carrierList.map((carrier) => {
            let row = {};
            row.businessName = GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs);
            row.carrierHQ = HQ_LOCATION_PARSER(carrier.city, carrier.state);
            row.customerCode = getCustomerCode(carrier.accountCarrierMaps, accountId);
            row.distance = IS_NOT_NULL_OR_UNDEFINED(carrier.distance)
                ? Math.round(carrier.distance)
                : null;
            row.dot = carrier.dot;
            row.mc = carrier.mc;
            row.drivers = carrier.drivers;
            row.powerUnits = carrier.powerUnits;
            row.customerCarrier = carrier.customerCarrier;
            row.id = carrier.id;
            row.active = carrier.active;
            row.hazmat = carrier.hazmat;
            row.hasTeams = carrier.hasTeams;
            row.hasTeamsUpdatedOn = carrier.hasTeamsUpdatedOn;
            if (IS_NOT_NULL_OR_UNDEFINED(carrier.contacts) && carrier.contacts.length > 0) {
                row.contactsTable = CONTACTS_TABLE(carrier.contacts[0]);
            }
            else {
                row.contactsTable = {};
            }
            row.carrierOnboardedOn = null;
            row.vettingSource = null;
            const accountCarrierMap = carrier?.accountCarrierMaps?.find((acm) => acm.accountId === accountId);
            if (accountCarrierMap) {
                row.carrierOnboardedOn = accountCarrierMap.carrierOnboardedOn;
                row.vettingSource = accountCarrierMap.vettingSource;
            }
            if (userCarrierMaps?.length) {
                const userCarrierMap = userCarrierMaps.find((ucm) => ucm.carrierId === carrier.id);
                if (userCarrierMap) {
                    row.userCarrierMap = userCarrierMap;
                    if (usersList?.length) {
                        const repAssigned = usersList?.find((user) => user.userId == userCarrierMap.assigneeId);
                        row.assignedRep = repAssigned;
                        row.assignedRepName = repAssigned?.name;
                    }
                }
            }
            if (!row.assignedRep) {
                row.assignedRepName = 'unassigned';
            }
            row.lanesCount = carrier.laneCount;
            row.contactsCount = carrier.contactCount;
            results.push(row);
        });
    }
    return results;
};
const getCustomerCode = (accountCarrierMaps, accountId) => {
    if (accountCarrierMaps != undefined &&
        accountCarrierMaps != null &&
        accountCarrierMaps &&
        accountCarrierMaps.length > 0) {
        const accountCarrierMap = accountCarrierMaps.find((accountCarrierMap) => accountCarrierMap.accountId == accountId);
        if (accountCarrierMap != undefined &&
            accountCarrierMap != null &&
            IS_NOT_EMPTY(accountCarrierMap.customerCode)) {
            return accountCarrierMap.customerCode;
        }
    }
};
const CONTACTS_TABLE = (contact) => {
    const contactsTable = {};
    if (IS_NOT_NULL_OR_UNDEFINED(contact)) {
        contactsTable.firstName = contact.firstName;
        contactsTable.lastName = contact.lastName;
        contactsTable.email = contact.emailAddress;
        contactsTable.phoneNumber = contact.phone;
        contactsTable.fullName = FULL_NAME(contactsTable.firstName, contactsTable.lastName);
    }
    return contactsTable;
};

var VETTING_SOURCE;
(function (VETTING_SOURCE) {
    VETTING_SOURCE["MY_CARRIER_PACKETS"] = "MY_CARRIER_PACKETS";
    VETTING_SOURCE["RMIS"] = "RMIS";
    VETTING_SOURCE["C4"] = "C4";
})(VETTING_SOURCE || (VETTING_SOURCE = {}));

const COLUMNS_VIEW = (labelText, labelValue, icons = [], valueType = [], valueUnit = [], rowClass = [], labelTextClass = [], labelValueClass = [], iconClass, labelValueFlexLayout = []) => {
    let results = [];
    labelText.map((label, index) => {
        let row = {};
        row.labelText = label;
        row.labelValue = labelValue[index];
        row.icon = icons.length > 0 ? icons[index] : '';
        row.valueType = valueType[index];
        row.valueUnit = valueUnit.length > 0 ? valueUnit[index] : '';
        if (rowClass.length > 0 && rowClass.length == 1) {
            row.rowClass = rowClass[0];
        }
        else if (rowClass.length > 1) {
            row.rowClass = rowClass[index];
        }
        else {
            row.rowClass = '';
        }
        if (labelTextClass.length > 0 && labelTextClass.length == 1) {
            row.labelTextClass = labelTextClass[0];
        }
        else if (labelTextClass.length > 1) {
            row.labelTextClass = labelTextClass[index];
        }
        else {
            row.labelTextClass = '';
        }
        if (labelValueClass.length > 0 && labelValueClass.length == 1) {
            row.labelValueClass = labelValueClass[0];
        }
        else if (labelValueClass.length > 1) {
            row.labelValueClass = labelValueClass[index];
        }
        else {
            row.labelValueClass = '';
        }
        if (iconClass.length > 0 && iconClass.length == 1) {
            row.iconClass = iconClass[0];
        }
        else if (iconClass.length > 1) {
            row.iconClass = iconClass[index];
        }
        else {
            row.iconClass = '';
        }
        if (labelValueFlexLayout.length > 0 && labelValueFlexLayout.length == 1) {
            row.labelValueFlexLayout = labelValueFlexLayout[0];
        }
        else if (labelValueFlexLayout.length > 1) {
            row.labelValueFlexLayout = labelValueFlexLayout[index];
        }
        else {
            row.labelValueFlexLayout = 'center center';
        }
        results.push(row);
    });
    return results;
};

const ADMIN_CAPACITY_EMAIL_LIST_TABLE = (capacityEmailList = []) => {
    let results = [];
    if (capacityEmailList.length > 0) {
        capacityEmailList.map((email, index) => {
            let row = {};
            row.attachmentProgressed = false;
            row.availableInC4 = email.firstTruckCreatedAt || '';
            if (email.carrier != undefined && email.carrier != null) {
                row.carrierMC = email.carrier.mc;
                row.carrierName = email.carrier.businessName;
            }
            else {
                row.carrierMC = '';
                row.carrierName = '';
            }
            row.parserUsed = email.parsingAlgorithmUsed || '';
            row.recievedOn = new Date(DATE_MDY(email.receivedOn)) || null;
            if (email.reviewStatus === 'reviewed' &&
                email.parsedCapacityEmailReviewedAt != undefined &&
                email.parsedCapacityEmailReviewedAt != null) {
                row.reviewedAt = new Date(DATE_MDY(email.parsedCapacityEmailReviewedAt));
            }
            else {
                row.reviewedAt = null;
            }
            row.senderEmailAddress = email.emailAddress || '';
            row.truckCount = email.parsedTrucksCount || null;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_LANES_LIST_TABLE = (carrierList = []) => {
    let results = [];
    if (carrierList.length > 0) {
        carrierList.map((lane) => {
            let row = {};
            row.destinationCity = lane.destCity;
            row.destinationState = lane.destState;
            row.destinationStates = lane.destinationStates;
            row.laneCount = lane.laneCount;
            row.originCity = lane.originCity;
            row.originState = lane.originState;
            row.trailerType = lane.trailerType;
            row.laneId = lane.laneId;
            results.push(row);
        });
    }
    return results;
};

const BROKER_LANE_DETAILS_TABLE = (lanesList = []) => {
    let results = [];
    if (lanesList.length > 0) {
        lanesList.map((lane) => {
            let row = {};
            row.origin =
                (IS_NOT_EMPTY(lane.originCity) ? lane.originCity + ', ' : '') +
                    (IS_NOT_EMPTY(lane.originState) ? lane.originState : '');
            if (IS_NOT_EMPTY(lane.destCity)) {
                row.destination = lane.destCity;
                if (IS_NOT_EMPTY(lane.destState)) {
                    row.destination += ', ' + lane.destState;
                }
            }
            else if (IS_NOT_EMPTY(lane.destState)) {
                row.destination = lane.destState;
            }
            else if (IS_NOT_EMPTY(lane.destinationStates)) {
                row.destination = lane.destinationStates;
            }
            else {
                row.destination = '';
            }
            row.equipment = lane.trailerType;
            row.frequency = getFrequency$1(lane);
            row.lastMatch = null;
            row.lastBooked = null;
            row.lastRate = IS_NOT_NULL_OR_UNDEFINED(lane.rate) ? lane.rate / 100 : null;
            row.carrierId = lane.carrierId;
            row.laneId = lane.id;
            row.rateUpdatedAt = lane.rateUpdatedAt;
            row.ltl = lane.ltl;
            results.push(row);
        });
    }
    return results;
};
const getFrequency$1 = (lane) => {
    let result = '';
    if (lane.runDaily != undefined && lane.runDaily != null && lane.runDaily) {
        result = 'Daily';
    }
    else if (lane.monday ||
        lane.tuesday ||
        lane.wednesday ||
        lane.thursday ||
        lane.friday ||
        lane.saturday ||
        lane.sunday) {
        let daysOfWeek = [];
        if (lane.monday) {
            daysOfWeek.push('M');
        }
        if (lane.tuesday) {
            daysOfWeek.push('T');
        }
        if (lane.wednesday) {
            daysOfWeek.push('W');
        }
        if (lane.thursday) {
            daysOfWeek.push('TH');
        }
        if (lane.friday) {
            daysOfWeek.push('F');
        }
        if (lane.saturday) {
            daysOfWeek.push('SAT');
        }
        if (lane.sunday) {
            daysOfWeek.push('SUN');
        }
        if (daysOfWeek.length > 0) {
            result = daysOfWeek.join(', ');
        }
    }
    else if (lane.weeklyFrequency != undefined && lane.weeklyFrequency != null) {
        result = lane.weeklyFrequency.toString();
    }
    return result;
};

const CARRIER_LANES_LIST_TABLE = (lanesList = []) => {
    let results = [];
    if (lanesList.length > 0) {
        lanesList.map((lane) => {
            let row = {};
            row.origin =
                (IS_NOT_EMPTY(lane.originCity) ? lane.originCity + ', ' : '') +
                    (IS_NOT_EMPTY(lane.originState) ? lane.originState : '');
            if (IS_NOT_EMPTY(lane.destCity)) {
                row.destination = lane.destCity;
                if (IS_NOT_EMPTY(lane.destState)) {
                    row.destination += ', ' + lane.destState;
                }
            }
            else if (IS_NOT_EMPTY(lane.destState)) {
                row.destination = lane.destState;
            }
            else {
                row.destination = '';
            }
            row.originMetadata = {
                latitude: IS_NOT_NULL_OR_UNDEFINED(lane.originLat) ? Number(lane.originLat) : null,
                longitude: IS_NOT_NULL_OR_UNDEFINED(lane.originLng) ? Number(lane.originLng) : null,
                zip: lane.originZip,
            };
            row.carrierId = lane.carrierId;
            row.trailerType = lane.trailerType;
            row.confirmationDate = new Date(DATE_MDY(lane.confirmationDate));
            row.backhaulAvailable = lane.hasBackhaulLane;
            if (row.destination.length == 0 && IS_NOT_EMPTY(lane.destinationStates)) {
                row.destination = null;
                row.destinationStates = lane.destinationStates.split(',');
            }
            row.destinationMetadata = {
                latitude: IS_NOT_NULL_OR_UNDEFINED(lane.destLat) ? Number(lane.destLat) : null,
                longitude: IS_NOT_NULL_OR_UNDEFINED(lane.destLng) ? Number(lane.destLng) : null,
                zip: lane.destZip,
            };
            row.id = lane.id;
            row.weeklyFrequency = lane.weeklyFrequency != null ? lane.weeklyFrequency : 1;
            row.runDaily = lane.runDaily != null ? lane.runDaily : false;
            row.monday = lane.monday != null ? lane.monday : false;
            row.tuesday = lane.tuesday != null ? lane.tuesday : false;
            row.wednesday = lane.wednesday != null ? lane.wednesday : false;
            row.thursday = lane.thursday != null ? lane.thursday : false;
            row.friday = lane.friday != null ? lane.friday : false;
            row.saturday = lane.saturday != null ? lane.saturday : false;
            row.sunday = lane.sunday != null ? lane.sunday : false;
            row.truckLaneId = lane.truckLaneId;
            row.age = lane.age;
            row.carrierLaneId = lane.carrierLaneId;
            row.destinationDeadhead = lane.destinationDeadhead;
            row.frequency = getFrequency$1(lane);
            row.fromCarrier = lane.fromCarrier;
            row.toBeReviewed = lane.toBeReviewed;
            row.originDeadheadLimit = lane.originDeadheadLimit;
            row.destinationDeadheadLimit = lane.destinationDeadheadLimit;
            row.ltl = lane.ltl;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_LANE_SEARCHES_TABLE = (laneSearches = []) => {
    let results = [];
    if (laneSearches.length > 0) {
        laneSearches.map((search) => {
            if (search.user != undefined && search.user != null) {
                let row = {};
                row.id = search.id;
                row.businessName = search.businessName;
                row.email = search.user.email;
                row.origin = search.originCity + ' ' + search.originState;
                row.destination = search.destCity + ' ' + search.destState;
                row.matchCount = search.resultCount;
                row.searchDate = search.createdAt;
                row.pickupDateStart = search.pickupDateStart;
                row.pickupDateEnd = search.pickupDateEnd;
                if (search.pickupDateStart != undefined &&
                    search.pickupDateStart != null &&
                    search.pickupDateEnd != undefined &&
                    search.pickupDateEnd != null) {
                    row.availableDates = ENUMERATE_DAYS_BETWEEN_DATES(search.pickupDateStart, search.pickupDateEnd);
                }
                else {
                    row.availableDates = '';
                }
                if (search.trailerTypes != undefined && search.trailerTypes != null) {
                    row.trailerType = search.trailerTypes.join(', ');
                }
                else {
                    row.trailerType = '';
                }
                results.push(row);
            }
        });
        return results;
    }
};

const ADMIN_LANE_SEARCH_DETAILS__TABLE = (laneSearches = []) => {
    let results = [];
    if (laneSearches.length > 0) {
        laneSearches.map((search) => {
            let row = {};
            row.businessName = search.businessName;
            row.origin = search.originCity + ' ' + search.originState;
            row.originDeadhead = search.originDeadhead;
            row.destination = search.destCity + ' ' + search.destState;
            row.postedOn = search.created;
            results.push(row);
        });
        return results;
    }
};

const HOT_LANE_TABLE = (hotLaneList) => {
    const result = [];
    if (IS_NOT_NULL_OR_UNDEFINED(hotLaneList) && hotLaneList.length > 0) {
        hotLaneList.forEach((hotLane) => {
            const hotLaneTable = {};
            hotLaneTable.origin = `${hotLane.originCity},${hotLane.originState}`;
            hotLaneTable.destination = `${hotLane.destCity},${hotLane.destState}`;
            hotLaneTable.trailerTypes = formatTrailerTypes(hotLane.trailerTypes);
            hotLaneTable.searchCount = hotLane.searchCount;
            result.push(hotLaneTable);
        });
    }
    return result;
};
const formatTrailerTypes = (input) => {
    let result = input;
    if (IS_NOT_EMPTY(input)) {
        result = input.split(',').reduce((pre, cur) => {
            pre += cur[0];
            return pre;
        }, '');
    }
    return result;
};

var LOAD_STATUS;
(function (LOAD_STATUS) {
    LOAD_STATUS["9bcd4613-831e-4cb4-a76f-9166ce559fa6"] = "Active";
    LOAD_STATUS["c05e4437-c750-480f-9ab3-639202cdb8f4"] = "Cancelled";
    LOAD_STATUS["adc9769e-d2d7-4931-b373-f0221dcef6c2"] = "Confirmed";
    LOAD_STATUS["b3f28d9e-828e-459f-ae5a-5db91cabb3e2"] = "Deleted";
    LOAD_STATUS["5eca0c1b-1282-49cc-8dc4-8e8eb205e1a1"] = "Delivered";
    LOAD_STATUS["dc9c55e1-e6f8-464e-9a52-b8913ce92ca5"] = "In Transit";
    LOAD_STATUS["9f45913b-e4c9-4e0e-a9fb-157fb41e508f"] = "EXPIRED";
    LOAD_STATUS["8fa3ae93-b79b-4059-8bfb-e868bc4f858b"] = "SELECTED";
})(LOAD_STATUS || (LOAD_STATUS = {}));
var LOAD_STATUS_STRING;
(function (LOAD_STATUS_STRING) {
    LOAD_STATUS_STRING["DELIVERED"] = "DELIVERED";
    LOAD_STATUS_STRING["ACTIVE"] = "ACTIVE";
    LOAD_STATUS_STRING["CONFIRMED"] = "CONFIRMED";
    LOAD_STATUS_STRING["DELETED"] = "DELETED";
    LOAD_STATUS_STRING["CANCELLED"] = "CANCELLED";
    LOAD_STATUS_STRING["IN_TRANSIT"] = "IN_TRANSIT";
    LOAD_STATUS_STRING["EXPIRED"] = "EXPIRED";
    LOAD_STATUS_STRING["SELECTED"] = "SELECTED";
})(LOAD_STATUS_STRING || (LOAD_STATUS_STRING = {}));
const LOAD_DISPLAY_STATUS_CONSTANTS = {
    DELIVERED: 'Delivered',
    ACTIVE: 'Active',
    CONFIRMED: 'Confirmed',
    DELETED: 'Deleted',
    CANCELLED: 'Cancelled',
    IN_TRANSIT: 'In Transit',
    EXPIRED: 'Expired',
    SELECTED: 'Selected',
};

const GET_LOAD_STATUS_CLASS = (status) => {
    switch (status.toLowerCase()) {
        case LOAD_STATUS_STRING.ACTIVE.toLowerCase():
        case LOAD_STATUS_STRING.DELIVERED.toLowerCase():
        case LOAD_STATUS_STRING.CONFIRMED.toLowerCase():
            return 'accepted-chip';
        case LOAD_STATUS_STRING.SELECTED.toLowerCase():
            return 'selected-chip';
        case LOAD_STATUS_STRING.IN_TRANSIT.toLowerCase() || LOAD_STATUS_STRING.CONFIRMED.toLowerCase():
            return 'countered-chip';
        case LOAD_STATUS_STRING.CANCELLED.toLowerCase() || LOAD_STATUS_STRING.DELETED.toLowerCase():
            return 'declined-chip';
        default:
            return '';
    }
};

const GET_LOAD_STATUS_TEXT = (status) => {
    switch (status.toLowerCase()) {
        case LOAD_STATUS_STRING.DELIVERED.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.DELIVERED;
        case LOAD_STATUS_STRING.ACTIVE.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.ACTIVE;
        case LOAD_STATUS_STRING.CONFIRMED.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.CONFIRMED;
        case LOAD_STATUS_STRING.DELETED.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.DELETED;
        case LOAD_STATUS_STRING.CANCELLED.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.CANCELLED;
        case LOAD_STATUS_STRING.IN_TRANSIT.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.IN_TRANSIT;
        case LOAD_STATUS_STRING.EXPIRED.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.EXPIRED;
        case LOAD_STATUS_STRING.SELECTED.toLowerCase():
            return LOAD_DISPLAY_STATUS_CONSTANTS.SELECTED;
        default:
            return 'Requested';
    }
};

const MY_LOADS_TABLE = (loadsList = []) => {
    let results = [];
    if (loadsList.length > 0) {
        loadsList.map((load) => {
            let row = {};
            row.created = load.created;
            row.deliveryDate = TIMESTAMP_FROM_STRING(FROM_UTC(load.deliveryDate)) || null;
            row.loadStatus = LOAD_STATUS[load.statusId];
            row.origin = LOCATION_PARSER(load.origin);
            row.destination = LOCATION_PARSER(load.destination);
            row.pickupDate = TIMESTAMP_FROM_STRING(FROM_UTC(load.pickupDate));
            row.price = Number(load.rate) || 0;
            row.trailerType = load.equipment[0].name || '';
            row.loadStatusClass = GET_LOAD_STATUS_CLASS(row.loadStatus);
            row.loadStatusText = GET_LOAD_STATUS_TEXT(row.loadStatus);
            row.loadId = load.id;
            if (load.bidCount == undefined || load.bidCount == null) {
                row.bidCount = null;
            }
            else {
                row.bidCount = load.bidCount;
            }
            if (load.quoteId == undefined || load.quoteId == null) {
                row.quoteId = null;
            }
            else {
                row.quoteId = load.quoteId;
            }
            row.url = load.url;
            row.destinationDTO = load.destination;
            row.originDTO = load.origin;
            row.referenceNumber = load.referenceNumber;
            row.productDescription = load.commodity;
            row.totalWeight = load.weight;
            row.declaredValue = load.declaredValue;
            row.teamServiceRequired = load.teamServiceRequired;
            row.revenueCode = load.revenueCode;
            row.customerName = load.customerName;
            const carrier = load.carrier;
            if (IS_NOT_NULL_OR_UNDEFINED(carrier)) {
                row.carrierId = carrier.id;
                row.carrierName = GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs);
            }
            if (load.userDTO) {
                row.userDTO = load.userDTO;
                row.userName = load.userDTO.firstName + ' ' + load.userDTO.lastName;
            }
            if (IS_NOT_NULL_OR_UNDEFINED(load.offersCount)) {
                row.offersCount = load.offersCount;
            }
            if (IS_NOT_NULL_OR_UNDEFINED(load.viewsCount)) {
                row.viewsCount = load.viewsCount;
            }
            results.push(row);
        });
    }
    return results;
};

const HISTORICAL_LOADS_TABLE = (loadsList = []) => {
    let results = [];
    if (loadsList.length > 0) {
        loadsList.map((load) => {
            let row = {};
            row.created = load.created;
            row.pickupDate = TIMESTAMP_FROM_STRING(load.pickupDate);
            row.deliveryDate = TIMESTAMP_FROM_STRING(load.deliveryDate);
            row.origin = HQ_LOCATION_PARSER(CAMEL_CASE(load.originCity), IS_NOT_EMPTY(load.originState) ? load.originState.toUpperCase() : '');
            row.destination = HQ_LOCATION_PARSER(CAMEL_CASE(load.destinationCity), IS_NOT_EMPTY(load.destinationState) ? load.destinationState.toUpperCase() : '');
            row.price = load.allInCost;
            row.priceToShipper = load.priceToShipper;
            row.trailerType = IS_NOT_EMPTY(load.equipment)
                ? load.equipment.toUpperCase()
                : load.equipment;
            row.loadId = load.id;
            row.referenceNumber = load.referenceNumber;
            row.productDescription = load.commodity;
            row.totalWeight = load.weight;
            const carrier = load.carrier;
            if (IS_NOT_NULL_OR_UNDEFINED(carrier)) {
                row.carrierId = carrier.id;
                row.carrierName = GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs);
            }
            row.customerName = load.customerName;
            row.predictedPrice = load.predictedPrice;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_OAUTH_LIST_TABLE = (oAuthClientList = []) => {
    let results = [];
    if (oAuthClientList.length > 0) {
        oAuthClientList.map((client) => {
            let row = {};
            row.accessTokenValidity = client.accessTokenValidity;
            row.authorities = client.authorities;
            row.authorizedGrantTypes = client.authorizedGrantTypes;
            row.cliendId = client.id;
            row.clientSecret = client.clientSecret;
            row.refreshTokenValidity = client.refreshTokenValidity;
            row.resourceIds = client.resourceIds;
            row.scope = client.scope;
            row.clientName = client.clientId;
            row.webServerRedirectURI = client.webServerRedirectUri;
            results.push(row);
        });
    }
    return results;
};

const CLIENT_PROFILE_ROWS = {
    clientID: 'Client ID:',
    resourceIDs: 'Resource IDs:',
    clientSecret: 'Client Secret:',
    scope: 'Scope:',
    authorizedGrantTypes: 'Authorized Grant Types:',
    webServerRedirectUri: 'Web Server Redirect Uri:',
    authorities: 'Authorities:',
    accessTokenValidity: 'Access Token Validity:',
    refreshTokenValidity: 'Refresh Token Validity:',
    additionalInformation: 'Additional Information:',
    autoApprove: 'Auto Approve:',
};

const QuoteViewTemplate = {
    origin: 'Origin',
    destination: 'Destination',
    trailerType: 'Trailer Type',
    description: 'Description',
    pickupDate: 'Pickup Date',
    deliveryDate: 'Delivery Date',
    totalWeight: 'Total Weight',
    reference: 'Reference #',
    revenueCode: 'Revenue Code',
    buyNowPrice: 'Buy Now Price',
};

var QUOTE_STATUS;
(function (QUOTE_STATUS) {
    QUOTE_STATUS["874cb3d3-8afc-4022-8f36-1a65df8d1357"] = "ACTIVE";
    QUOTE_STATUS["edd2e47a-73a7-406b-85cc-1c339993fdd9"] = "CANCELLED";
    QUOTE_STATUS["0b20aa5d-f6a0-4c29-a258-05c78547ee72"] = "DRAFT";
    QUOTE_STATUS["753ad3ba-e4dc-4e2a-a3d4-494a483df6d3"] = "EXPIRED";
    QUOTE_STATUS["b3713346-bdfd-4a6a-a1ec-3bbbe8e25836"] = "FILLED";
})(QUOTE_STATUS || (QUOTE_STATUS = {}));
var QUOTE_STATUS_STRING;
(function (QUOTE_STATUS_STRING) {
    QUOTE_STATUS_STRING["DRAFT"] = "DRAFT";
    QUOTE_STATUS_STRING["EXPIRED"] = "EXPIRED";
    QUOTE_STATUS_STRING["ACTIVE"] = "ACTIVE";
    QUOTE_STATUS_STRING["FILLED"] = "FILLED";
    QUOTE_STATUS_STRING["CANCELLED"] = "CANCELLED";
})(QUOTE_STATUS_STRING || (QUOTE_STATUS_STRING = {}));

const DEFAULT_SORT_PROPERTY = 'frequency';
const SEARCH_TRUCK_TABLE = (truckSearchResult = [], searchedDestinationState) => {
    let searchResults = [];
    if (truckSearchResult.length > 0) {
        truckSearchResult.map((response) => {
            if (response.trucks != undefined && response.trucks != null && response.trucks.length > 0) {
                response.trucks.map((searchedTruck) => {
                    let truck = {};
                    truck.businessName = GET_CARRIER_BUSINESS_NAME(response.carrier.businessName, response.carrier.doingBusinessAs);
                    truck.oldCarrierId =
                        response.carrier.carrierId != undefined && response.carrier.carrierId != null
                            ? response.carrier.carrierId
                            : null;
                    truck.carrierId = response.carrier.carrierHubId;
                    truck.customerCarrier = response.carrier.customerCarrier;
                    truck.originDeadhead = searchedTruck.originDeadhead;
                    truck.firmDot = response.carrier.firmDot || null;
                    truck.firmMc = response.carrier.firmMc || null;
                    truck.customerCode = response.carrier.customerCode;
                    truck.location = LOCATION_PARSER(searchedTruck.loadStops[0].address);
                    if (LOCATION_PARSER(searchedTruck.loadStops[searchedTruck.loadStops.length - 1].address)
                        .length == 0) {
                        if (searchedTruck.destinationStates.some((state) => state.toLowerCase() == searchedDestinationState.toLowerCase())) {
                            truck.location +=
                                ' -> ' +
                                    searchedTruck.destinationStates.find((x) => x.toLowerCase() === searchedDestinationState.toLowerCase());
                        }
                    }
                    else {
                        truck.location +=
                            ' -> ' +
                                LOCATION_PARSER(searchedTruck.loadStops[searchedTruck.loadStops.length - 1].address);
                    }
                    truck.carrierHQ =
                        (response.carrier.city != undefined && response.carrier.city != null
                            ? response.carrier.city + ', '
                            : '') +
                            (response.carrier.state != undefined && response.carrier.state != null
                                ? response.carrier.state
                                : '');
                    truck.match = searchedTruck.rating.score;
                    if (response.isLane != undefined && response.isLane != null && response.isLane) {
                        truck.isLane = true;
                        truck.lanePath =
                            LOCATION_PARSER_WITHOUT_ZIP(searchedTruck.loadStops[0].address) + ' -> ';
                        if (LOCATION_PARSER_WITHOUT_ZIP(searchedTruck.loadStops[searchedTruck.loadStops.length - 1].address).length == 0) {
                            if (searchedTruck.destinationStates.some((state) => state.toLowerCase() == searchedDestinationState.toLowerCase())) {
                                truck.lanePath += searchedTruck.destinationStates.find((x) => x.toLowerCase() === searchedDestinationState.toLowerCase());
                            }
                        }
                        else {
                            truck.lanePath += LOCATION_PARSER_WITHOUT_ZIP(searchedTruck.loadStops[searchedTruck.loadStops.length - 1].address);
                        }
                    }
                    else {
                        truck.availableDate = searchedTruck.availableDate;
                        truck.isLane = false;
                    }
                    truck.drivers = response.carrier.drivers;
                    truck.carrierLastFmcsaUpdate = response.carrier.carrierLastFmcsaUpdate;
                    truck.powerUnits = response.carrier.powerUnits;
                    truck.phone = response.carrier.phone;
                    if (response.carrier.brokerExclusivity != undefined &&
                        response.carrier.brokerExclusivity != null) {
                        truck.brokerExclusivity = response.carrier.brokerExclusivity;
                    }
                    else {
                        truck.brokerExclusivity = null;
                    }
                    truck.frequency = getFrequency(searchedTruck);
                    truck.destinationDeadhead = searchedTruck.destinationDeadhead;
                    POPULATE_ORIGIN(truck, searchedTruck.loadStops[0].address);
                    POPULATE_DESTINATION(truck, searchedTruck.loadStops[1].address);
                    // set origin, destination, empty location is not supported by feedback
                    if (IS_EMPTY(truck.originCity)) {
                        if (IS_NOT_EMPTY(response.carrier.city)) {
                            truck.originCity = response.carrier.city;
                        }
                        else if (IS_NOT_EMPTY(truck.originState)) {
                            truck.originCity = truck.originState;
                        }
                    }
                    if (IS_EMPTY(truck.originState)) {
                        if (IS_NOT_EMPTY(response.carrier.state)) {
                            truck.originState = response.carrier.state;
                        }
                    }
                    if (IS_EMPTY(truck.destCity)) {
                        truck.destCity = searchedDestinationState;
                    }
                    if (IS_EMPTY(truck.destState)) {
                        truck.destState = searchedDestinationState;
                    }
                    truck.trailerTypes = searchedTruck.trailerType;
                    truck.id = searchedTruck.truckId;
                    truck.isTruckAndLane = false;
                    truck.showAvailableDate = false;
                    truck.searchId = truck.isLane ? response.truckLaneSearchId : response.truckSearchId;
                    truck.notesCount = response.carrier.notesCount;
                    truck.recentFeedbackDate = response.recentFeedbackDate;
                    truck.rate = searchedTruck.rate;
                    truck.laneIds = response.laneIds;
                    truck.hazmat = response.carrier.hazmat;
                    truck.hasTeams = response.carrier.hasTeams;
                    truck.hasTeamsUpdatedOn = response.carrier.hasTeamsUpdatedOn;
                    truck.active = response.carrier.active;
                    truck.carrierOnboardedOn = response.carrier.carrierOnboardedOn;
                    truck.vettingSource = response.carrier.vettingSource;
                    truck.authorityGrantDate = response.carrier.authorityGrantDate
                        ? DATE_MDY(response.carrier.authorityGrantDate)
                        : 'N/A';
                    truck.bipdInsuranceAmount = response.carrier.bipdInsuranceAmount;
                    searchResults.push(truck);
                });
            }
        });
        searchResults = [...combineTruckAndLane(searchResults)];
        searchResults = [...sortSearchList(searchResults)];
    }
    return searchResults;
};
const sortSearchList = (list) => {
    if (DEFAULT_SORT_PROPERTY == 'frequency') {
        let frequencyDaily = [], frequentDays = [], frequencyNumber = [], result = [];
        list.map((search, index) => {
            if (search.frequency == 'Daily')
                frequencyDaily.push(index);
            else if (!/\D/.test(search.frequency))
                frequencyNumber.push(index);
            else
                frequentDays.push(index);
        });
        frequencyDaily.map((searchIndex) => result.push(list[searchIndex]));
        frequentDays.map((searchIndex) => result.push(list[searchIndex]));
        frequencyNumber
            .sort((a, b) => 0 - (Number(list[a].frequency) > Number(list[b].frequency) ? 1 : -1))
            .map((searchIndex) => result.push(list[searchIndex]));
        return result;
    }
    return list.sort((left, right) => {
        if (left[DEFAULT_SORT_PROPERTY] > right[DEFAULT_SORT_PROPERTY])
            return -1;
        if (left[DEFAULT_SORT_PROPERTY] < right[DEFAULT_SORT_PROPERTY])
            return 1;
        return 0;
    });
};
const getFrequency = (searchedTruck) => {
    let result = '';
    if (searchedTruck.runDaily != undefined &&
        searchedTruck.runDaily != null &&
        searchedTruck.runDaily) {
        result = 'Daily';
    }
    else if (searchedTruck.monday ||
        searchedTruck.tuesday ||
        searchedTruck.wednesday ||
        searchedTruck.thursday ||
        searchedTruck.friday ||
        searchedTruck.saturday ||
        searchedTruck.sunday) {
        let daysOfWeek = [];
        if (searchedTruck.monday) {
            daysOfWeek.push('M');
        }
        if (searchedTruck.tuesday) {
            daysOfWeek.push('T');
        }
        if (searchedTruck.wednesday) {
            daysOfWeek.push('W');
        }
        if (searchedTruck.thursday) {
            daysOfWeek.push('TH');
        }
        if (searchedTruck.friday) {
            daysOfWeek.push('F');
        }
        if (searchedTruck.saturday) {
            daysOfWeek.push('SAT');
        }
        if (searchedTruck.sunday) {
            daysOfWeek.push('SUN');
        }
        if (daysOfWeek.length > 0) {
            result = daysOfWeek.join(', ');
        }
    }
    else if (searchedTruck.weeklyFrequency != undefined && searchedTruck.weeklyFrequency != null) {
        result = searchedTruck.weeklyFrequency.toString();
    }
    return result;
};
const combineTruckAndLane = (searchList) => {
    const result = searchList.reduce((acc = [], current) => {
        const x = acc.find((item) => item.carrierId === current.carrierId);
        if (!x) {
            return acc.concat([current]);
        }
        else {
            let ind = null;
            acc.map((search, index) => {
                if (ind == null && search.carrierId == current.carrierId)
                    ind = index;
            });
            if (ind != null) {
                if (acc[ind].isLane && !current.isLane) {
                    acc[ind].isTruckAndLane = true;
                }
                if (acc[ind].match < current.match) {
                    acc[ind].originDeadhead = current.originDeadhead;
                    acc[ind].destinationDeadhead = current.destinationDeadhead;
                    acc[ind].availableDate = current.availableDate;
                    acc[ind].match = current.match;
                    acc[ind].location = current.location;
                    acc[ind].lanePath = current.lanePath;
                    acc[ind].carrierHQ = current.carrierHQ;
                    acc[ind].originCity = current.originCity;
                    acc[ind].originState = current.originState;
                    acc[ind].destCity = current.destCity;
                    acc[ind].destState = current.destState;
                    acc[ind].trailerTypes = current.trailerTypes;
                    acc[ind].id = current.id;
                }
            }
            return acc;
        }
    }, []);
    return result;
};

const SEARCH_CARRIER_ONLY_TABLE = (truckSearchResult) => {
    let allCapacitySearchResults = [];
    allCapacitySearchResults = truckSearchResult.map((response) => {
        let truck = {};
        truck.businessName = GET_CARRIER_BUSINESS_NAME(response.carrier.businessName, response.carrier.doingBusinessAs);
        truck.oldCarrierId =
            response.carrier.carrierId != undefined && response.carrier.carrierId != null
                ? response.carrier.carrierId
                : null;
        truck.carrierId = response.carrier.carrierHubId;
        truck.customerCarrier = response.carrier.customerCarrier;
        truck.firmDot = response.carrier.dot || null;
        truck.firmMc = response.carrier.mc || null;
        truck.customerCode = response.carrier.customerCode;
        truck.carrierHQ =
            (response.carrier.city != undefined && response.carrier.city != null
                ? response.carrier.city + ', '
                : '') +
                (response.carrier.state != undefined && response.carrier.state != null
                    ? response.carrier.state
                    : '');
        truck.isLane = false;
        truck.drivers = response.carrier.drivers;
        truck.carrierLastFmcsaUpdate = response.carrier.carrierLastFmcsaUpdate;
        truck.powerUnits = response.carrier.powerUnits;
        truck.phone = response.carrier.phone;
        if (response.carrier.brokerExclusivity != undefined &&
            response.carrier.brokerExclusivity != null) {
            truck.brokerExclusivity = response.carrier.brokerExclusivity;
        }
        else {
            truck.brokerExclusivity = null;
        }
        truck.isTruckAndLane = false;
        truck.showAvailableDate = false;
        truck.searchId = truck.isLane ? response.truckLaneSearchId : response.truckSearchId;
        truck.notesCount = response.carrier.notesCount;
        truck.recentFeedbackDate = response.recentFeedbackDate;
        truck.laneIds = response.laneIds;
        truck.hazmat = response.carrier.hazmat;
        truck.hasTeams = response.carrier.hasTeams;
        truck.hasTeamsUpdatedOn = response.carrier.hasTeamsUpdatedOn;
        truck.active = response.carrier.active;
        truck.authorityGrantDate = DATE_MDY(response.carrier.authorityGrantDate);
        truck.carrierContactsCount = response.carrier.contactCount;
        truck.lanesCount = 0;
        truck.notesCount = 0;
        return truck;
    });
    return allCapacitySearchResults;
};

const ADMIN_TRUCK_SEARCHES_LIST_TABLE = (truckSearchesList = []) => {
    let results = [];
    if (truckSearchesList.length > 0) {
        truckSearchesList.map((search, index) => {
            let row = {};
            row.businessName = search.businessName;
            row.destination = search.destCity + ' ' + search.destState;
            row.email = search.user != null ? search.user.email : '';
            row.matchCount = search.truckSearchResults.length;
            row.origin = search.originCity + ' ' + search.originState;
            row.searchDate = search.createdAt;
            row.id = search.id;
            results.push(row);
            if (search.pickupDateStart != undefined &&
                search.pickupDateStart != null &&
                search.pickupDateEnd != undefined &&
                search.pickupDateEnd != null) {
                row.availableDates = ENUMERATE_DAYS_BETWEEN_DATES(search.pickupDateStart, search.pickupDateEnd);
            }
            else {
                row.availableDates = '';
            }
            if (search.trailerTypes != undefined && search.trailerTypes != null) {
                row.trailerType = search.trailerTypes.join(', ');
            }
            else {
                row.trailerType = '';
            }
        });
    }
    return results;
};

const ADMIN_LANE_SEARCH_LIST_TABLE = (searchList = []) => {
    let results = [];
    if (searchList.length > 0) {
        searchList.map((search) => {
            let row = {};
            if (search.trucks.length > 0) {
                row.age = search.trucks[0].age;
                row.ageDeduction = search.trucks[0].rating.ageDeduction || 0;
                row.destinationDeduction = search.trucks[0].rating.destinationDeduction || 0;
                row.dh0 = search.trucks[0].originDeadhead || 0;
                row.dhD = search.trucks[0].originDeadhead || 0;
                row.match = search.trucks[0].rating.score || 0;
                row.origin =
                    search.trucks[0].loadStops[0].address.city +
                        ' ' +
                        search.trucks[0].loadStops[0].address.state || '';
                row.originDeduction = search.trucks[0].rating.originDeduction || 0;
                row.postedOn = search.trucks[0].postedOn;
                row.trailerType = search.trucks[0].trailerType;
            }
            row.businessName = search.carrier.businessName;
            row.carrierId = search.carrier.carrierHubId;
            results.push(row);
        });
    }
    return results;
};

const ADMIN_TRUCK_SEARCH_RESULTS_LIST_TABLE = (searchList = []) => {
    let results = [];
    if (searchList.length > 0) {
        searchList.map((search) => {
            let row = {};
            row.businessName = search.businessName;
            row.origin = search.originCity + ', ' + search.originState;
            row.originDeadhead = search.originDeadhead;
            row.destination = search.destCity + ', ' + search.destState;
            row.postedOn = search.created;
            results.push(row);
        });
    }
    return results;
};

const EXCLUDED_CARRIERS_TABLE = (carriersResponseList = []) => {
    let results = [];
    if (carriersResponseList.length > 0) {
        carriersResponseList.map((carrier) => {
            let row = {};
            row.businessName = GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs);
            row.dot = carrier.dot || '';
            row.excluded = carrier.excluded || false;
            row.mc = carrier.mc || '';
            row.id = carrier.id;
            results.push(row);
        });
    }
    return results;
};

const REVIEW_TRUCK_LIST_TABLE = (truckList = []) => {
    let results = [];
    if (truckList.length > 0) {
        truckList.map((truck) => {
            let row = {};
            row.destinations = [];
            if (truck.destinations != undefined &&
                truck.destinations != null &&
                truck.destinations.length > 0) {
                const destination = JSON.parse(truck.destinations);
                destination.map((destination) => {
                    var location = { city: '', state: '' };
                    if (destination.city != undefined &&
                        destination.city != null &&
                        destination.city.length > 0) {
                        location.city = destination.city;
                    }
                    if (destination.state != undefined &&
                        destination.state != null &&
                        destination.state.length > 0) {
                        location.state = destination.state;
                    }
                    row.destinations.push(location);
                });
            }
            row.id = truck.id;
            row.carrierHubId = truck.carrierHubId;
            row.trailerType = truck.trailerType;
            row.availableDate = truck.availableDate;
            row.availableTime = truck.availableTime;
            row.origin = truck.origin;
            row.originString = LOCATION_PARSER(truck.origin);
            row.carrier = truck.carrier;
            row.contactName = truck.contactName;
            row.contactEmail = truck.contactEmail;
            row.contactPhone = truck.contactPhone;
            row.contactMobile = truck.contactMobile;
            results.push(row);
        });
    }
    return results;
};

var PROJECT_STAGE_UUID;
(function (PROJECT_STAGE_UUID) {
    PROJECT_STAGE_UUID["5038a0c7-500a-4eee-8ab4-236fa636fb55"] = "Awarded";
    PROJECT_STAGE_UUID["ad869dd5-52bc-44f6-8ef6-6bdf41b7dc22"] = "On Hold";
    PROJECT_STAGE_UUID["b4bccac6-5ac9-451e-9d68-f235f0e3fd49"] = "Re Bid";
    PROJECT_STAGE_UUID["de189832-5dc1-44f8-8121-e1f3ed725378"] = "New";
    PROJECT_STAGE_UUID["fa486cf3-7cae-4d21-81ee-64d85f769a1d"] = "Live";
    PROJECT_STAGE_UUID["3380b684-1b5c-4200-8c21-c7e6af65cdce"] = "Submitted";
})(PROJECT_STAGE_UUID || (PROJECT_STAGE_UUID = {}));
const PROJECT_STAGE_UUID_MAP = {
    AWARDED: '5038a0c7-500a-4eee-8ab4-236fa636fb55',
    ON_HOLD: 'ad869dd5-52bc-44f6-8ef6-6bdf41b7dc22',
    RE_BID: 'b4bccac6-5ac9-451e-9d68-f235f0e3fd49',
    NEW: 'de189832-5dc1-44f8-8121-e1f3ed725378',
    LIVE: 'fa486cf3-7cae-4d21-81ee-64d85f769a1d',
    SUBMITTED: '3380b684-1b5c-4200-8c21-c7e6af65cdce',
};

const PROJECT_POSITIONS = {
    Primary: 'Primary',
    Seconday: 'Secondary',
};

const LOAD_VOLUME_DURATION = {
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    YEAR: 'Year',
};

const PROJECT_CARRIER_MAP_STATUS = {
    PROCURED: 'PROCURED',
    IN_PROGRESS: 'IN_PROGRESS',
};

const GET_LANE_PATH_STRING = (project) => {
    let result = '';
    if (IS_NOT_EMPTY(project.originCity) &&
        IS_NOT_EMPTY(project.originState) &&
        IS_NOT_EMPTY(project.destCity) &&
        IS_NOT_EMPTY(project.destState) &&
        IS_NOT_EMPTY(project.equipmentType)) {
        result =
            project.originCity +
                ', ' +
                project.originState +
                ' -> ' +
                project.destCity +
                ', ' +
                project.destState +
                ' (' +
                project.equipmentType.split(', ').map((e) => e.toUpperCase()) +
                ')';
    }
    return result;
};

const BROKER_PROJECTS_TABLE = (projectDTOList = [], isAnnualVolumeEnabled = false, userId = null, usersList = []) => {
    let results = [];
    if (projectDTOList.length > 0) {
        projectDTOList.map((projectDTO) => {
            let project = {};
            project.name = projectDTO.name;
            project.dueDate = DATE_MDY(projectDTO.dueDate);
            project.carrierCount = projectDTO.carrierCount;
            project.id = projectDTO.id;
            project.userId = projectDTO.userId;
            project.assigneeId = projectDTO.assigneeId;
            project.assignee = projectDTO.assignee;
            project.customerDTO = projectDTO.customerDTO;
            project.minRate =
                IS_NOT_NULL_OR_UNDEFINED(projectDTO.minRate) && projectDTO.minRate > 0
                    ? TO_DOLLARS(projectDTO.minRate)
                    : null;
            project.maxRate =
                IS_NOT_NULL_OR_UNDEFINED(projectDTO.maxRate) && projectDTO.maxRate > 0
                    ? TO_DOLLARS(projectDTO.maxRate)
                    : null;
            project.maxBuy =
                IS_NOT_NULL_OR_UNDEFINED(projectDTO.maxBuy) && projectDTO.maxBuy > 0
                    ? TO_DOLLARS(projectDTO.maxBuy)
                    : null;
            project.value =
                IS_NOT_NULL_OR_UNDEFINED(projectDTO.value) && projectDTO.value > 0
                    ? TO_DOLLARS(projectDTO.value)
                    : null;
            project.commodity = projectDTO.commodity;
            project.loadVolume = projectDTO.loadVolume;
            project.daysRun = GET_LOAD_VOLUME(projectDTO);
            project.packaging = projectDTO.packaging;
            project.trailerRequirements = projectDTO.trailerRequirements;
            project.shipperNotes = projectDTO.shipperNotes;
            project.receiverNotes = projectDTO.receiverNotes;
            project.lanePath = GET_LANE_PATH_STRING(projectDTO);
            project.taskCount = projectDTO.taskCount;
            project.loadCapacity = projectDTO.loadCapacity;
            project.loadCount = projectDTO.loadCount;
            project.stageId = projectDTO.stageId;
            project.loadVolumeDuration = projectDTO.loadVolumeDuration;
            project.position = PROJECT_POSITIONS[projectDTO.position];
            project.monday = projectDTO.monday;
            project.tuesday = projectDTO.tuesday;
            project.wednesday = projectDTO.wednesday;
            project.thursday = projectDTO.thursday;
            project.friday = projectDTO.friday;
            project.saturday = projectDTO.saturday;
            project.sunday = projectDTO.sunday;
            project.selectedDaysRun = project.daysRun.split(', ');
            project.dueDateFormControl = new FormControl(new Date(DATE_MDY(projectDTO.dueDate)), Validators.required);
            project.lastBid = projectDTO.lastBid;
            project.bestRate = projectDTO.bestRate;
            project.probability = projectDTO.probability;
            project.isAssigneeEnabled = false;
            if (IS_NOT_NULL_OR_UNDEFINED(userId)) {
                project.isAssigneeEnabled = userId == projectDTO.userId;
            }
            project.assigneePlaceholder = 'Unassigned';
            project.selectedAssigneeIds = IS_NOT_NULL_OR_UNDEFINED(projectDTO.assigneeId)
                ? [projectDTO.assigneeId]
                : [];
            if (IS_NOT_NULL_OR_UNDEFINED(projectDTO.minRate) &&
                IS_NOT_NULL_OR_UNDEFINED(projectDTO.maxRate)) {
                project.targetMargin = Math.round(Number(((project.maxRate - project.minRate) / project.maxRate) * 100));
            }
            const annualVolume = ANNUAL_VOLUME_DISPLAY(projectDTO);
            if (isAnnualVolumeEnabled) {
                if (IS_NOT_NULL_OR_UNDEFINED(projectDTO.loadVolume) &&
                    IS_NOT_NULL_OR_UNDEFINED(projectDTO.loadVolumeDuration)) {
                    project.annualVolumeDisplay = annualVolume;
                    project.annualVolumeTooltip = `${projectDTO.loadVolume}/${projectDTO.loadVolumeDuration}`;
                    project.opportunityValue = OPPORTUNITY_VALUE(projectDTO, project.annualVolumeDisplay);
                }
                else {
                    project.annualVolumeDisplay = '';
                    project.annualVolumeTooltip = '';
                }
            }
            setShowProjectname(project);
            if (IS_NOT_NULL_OR_UNDEFINED(userId) &&
                IS_NOT_NULL_OR_UNDEFINED(usersList) &&
                usersList.length > 0) {
                const user = usersList.find((user) => user.userId == projectDTO.userId);
                project.ownerName = IS_NOT_NULL_OR_UNDEFINED(user) ? user.name : '';
            }
            if (IS_NOT_NULL_OR_UNDEFINED(userId) &&
                IS_NOT_NULL_OR_UNDEFINED(usersList) &&
                usersList.length > 0) {
                project.isAssigneeEnabled = userId == project.userId;
                if (!project.isAssigneeEnabled) {
                    project.usersList = [];
                    if (IS_NOT_NULL_OR_UNDEFINED(projectDTO.assigneeId)) {
                        const user = usersList.find((user) => user.id == projectDTO.assigneeId);
                        usersList.map((user) => {
                            if (project.selectedAssigneeIds.indexOf(user.userId) > -1) {
                                project.assigneePlaceholder = user.name + ' ';
                            }
                        });
                    }
                }
                else {
                    project.usersList = usersList.map((user) => {
                        let userCopy = Object.assign({}, user);
                        if (project.selectedAssigneeIds.indexOf(user.userId) > -1) {
                            project.assigneePlaceholder = user.name + ' ';
                            userCopy.selected = true;
                        }
                        return userCopy;
                    });
                }
            }
            project.weight = projectDTO.weight;
            if (IS_NOT_NULL_OR_UNDEFINED(annualVolume)) {
                project.monthlyVolumeDisplay = `${Math.round(annualVolume / 12)}/Month`;
            }
            project.type = projectDTO.type;
            results.push(project);
        });
    }
    return results;
};
const GET_LOAD_VOLUME = (projectDTO) => {
    let result = '';
    if (projectDTO.monday ||
        projectDTO.tuesday ||
        projectDTO.wednesday ||
        projectDTO.thursday ||
        projectDTO.friday ||
        projectDTO.saturday ||
        projectDTO.sunday) {
        let daysOfWeek = [];
        if (projectDTO.monday) {
            daysOfWeek.push('M');
        }
        if (projectDTO.tuesday) {
            daysOfWeek.push('T');
        }
        if (projectDTO.wednesday) {
            daysOfWeek.push('W');
        }
        if (projectDTO.thursday) {
            daysOfWeek.push('TH');
        }
        if (projectDTO.friday) {
            daysOfWeek.push('F');
        }
        if (projectDTO.saturday) {
            daysOfWeek.push('SAT');
        }
        if (projectDTO.sunday) {
            daysOfWeek.push('SUN');
        }
        if (daysOfWeek.length > 0) {
            result = daysOfWeek.join(', ');
        }
    }
    return result;
};
const UPDATE_PROJECT_BY_USERID = (projectList, userId) => {
    if (projectList.length > 0) {
        projectList.map((project) => {
            project.isAssigneeEnabled = userId == project.userId;
            if (IS_NOT_NULL_OR_UNDEFINED(project.assigneeId) && userId == project.userId) {
                project.assigneePlaceholder = 'Assign User';
            }
        });
    }
    return projectList;
};
const ANNUAL_VOLUME_DISPLAY = (projectDTO) => {
    switch (projectDTO.loadVolumeDuration?.toLowerCase()) {
        case LOAD_VOLUME_DURATION.DAY.toLowerCase():
            return projectDTO.loadVolume * 365;
        case LOAD_VOLUME_DURATION.WEEK.toLowerCase():
            return projectDTO.loadVolume * 52;
        case LOAD_VOLUME_DURATION.MONTH.toLowerCase():
            return projectDTO.loadVolume * 12;
        case LOAD_VOLUME_DURATION.YEAR.toLowerCase():
            return projectDTO.loadVolume;
        default:
            return null;
    }
};
const OPPORTUNITY_VALUE = (projectDTO, annualVolumeDisplay) => {
    if (IS_NOT_NULL_OR_UNDEFINED(projectDTO.maxRate) &&
        IS_NOT_NULL_OR_UNDEFINED(annualVolumeDisplay)) {
        return Math.abs(annualVolumeDisplay * (projectDTO.maxRate / 100));
    }
    return '';
};
const setShowProjectname = (project) => {
    if (IS_EMPTY(project.lanePath)) {
        project.showProjectName = project.isProjectNameDisplayed = true;
        return;
    }
    project.showProjectName = project.isProjectNameDisplayed = false;
    if (project.lanePath == project.name) {
        return;
    }
    if (IS_NOT_NULL_OR_UNDEFINED(project.customerDTO) &&
        project.customerDTO.name.toLowerCase() == project.name.toLowerCase()) {
        return;
    }
    project.showProjectName = project.isProjectNameDisplayed = true;
};

const GET_NAME_FROM_LANE_AND_EQIUPMENT = ({ originCity, originState, destCity, destState, equipmentType, }) => {
    const equipment = equipmentType
        ?.split(',')
        .map((equip) => equip[0])
        .join(',');
    return `${originCity}, ${originState} -> ${destCity}, ${destState} (${equipment})`;
};

const GET_PROJECTED_MARGIN = (project) => {
    let projectedMargin = null;
    if (IS_NOT_NULL_OR_UNDEFINED(project)) {
        const bestRateInCents = project.bestRate;
        const lastBidInCents = project.lastBid;
        if (IS_NOT_NULL_OR_UNDEFINED(bestRateInCents) && IS_NOT_NULL_OR_UNDEFINED(lastBidInCents)) {
            const bestRate = bestRateInCents / 100, lastBid = lastBidInCents / 100;
            projectedMargin = (lastBid - bestRate) / lastBid;
        }
    }
    return projectedMargin;
};

const QUICK_SEARCH_TABLE = (projects, usersList = []) => {
    let results = [];
    if (projects.length > 0) {
        projects.map((projectDTO) => {
            let project = {};
            project.id = projectDTO.id;
            project.name = projectDTO.name;
            project.laneName = GET_LANE_PATH_STRING(projectDTO);
            project.assigneeId = projectDTO.assigneeId;
            project.userId = projectDTO.userId;
            project.dueDate = DATE_MDY(projectDTO.dueDate);
            const user = usersList.find((user) => projectDTO.userId == user.id);
            if (IS_NOT_NULL_OR_UNDEFINED(user)) {
                project.ownerName = FULL_NAME(user.firstName, user.lastName);
            }
            let projectedMargin = GET_PROJECTED_MARGIN(projectDTO);
            if (IS_NOT_NULL_OR_UNDEFINED(projectedMargin)) {
                projectedMargin = Math.round(projectedMargin * 100);
                project.projectedMargin = `${projectedMargin} %`;
            }
            results.push(project);
        });
    }
    return results;
};

const RECENT_TRANSACTIONS_TABLE = (transactionsList) => {
    let recentTransactions = [];
    if (transactionsList.length > 0) {
        transactionsList.map((transaction) => {
            let recentTransaction = {};
            recentTransaction.origin = `${transaction.originCity},${transaction.originState}`;
            recentTransaction.destination = `${transaction.destinationCity},${transaction.destinationState}`;
            recentTransaction.trailerType = `${transaction.equipment.charAt(0).toUpperCase() + transaction.equipment.slice(1)}`;
            recentTransaction.allInCost = transaction.allInCost / 100;
            recentTransaction.originDeadhead = Math.round(transaction.originDeadhead);
            recentTransaction.destinationDeadhead = Math.round(transaction.destinationDeadhead);
            recentTransaction.pickupDate = DATE_MDY(transaction.pickupDate);
            let pricePerMile = transaction.allInCost / 100 / transaction.miles;
            recentTransaction.pricePerMile = Math.round(pricePerMile * 100) / 100;
            recentTransaction.age = formatAge(transaction.age);
            recentTransaction.miles = transaction.miles;
            recentTransaction.LoH = transaction.miles;
            recentTransaction.forThisAccount = transaction.forThisAccount;
            recentTransaction.deadheadDiff = Math.round(transaction.originDeadhead + transaction.destinationDeadhead);
            recentTransactions.push(recentTransaction);
        });
    }
    return recentTransactions;
};
const formatAge = (age) => {
    let hours = '00', minutes = '00';
    if (age > 59) {
        hours = Math.floor(age / 60).toString();
    }
    if (age % 60 > 0) {
        minutes = (age % 60).toString();
    }
    return `${hours}:${minutes}`;
};

const POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE = (transactions, accountId) => {
    let transactionsCopy = [];
    if (IS_NOT_NULL_OR_UNDEFINED(transactions) && transactions.length > 0) {
        transactionsCopy = [...transactions];
        transactionsCopy.forEach((transaction) => {
            transaction.forThisAccount = transaction.accountId == accountId;
        });
    }
    return transactionsCopy;
};

const USAGE_REPORT_TABLE = (usageReportResponseList = []) => {
    let results = [];
    if (IS_NULL_OR_UNDEFINED(usageReportResponseList) || usageReportResponseList.length == 0) {
        return results;
    }
    usageReportResponseList.map((usageReportResponse) => {
        let row = {};
        row.userId = usageReportResponse.userId;
        row.userName = FULL_NAME(usageReportResponse.firstName, usageReportResponse.lastName);
        row.totalFeedbackCount = usageReportResponse.totalFeedbackCount || 0;
        row.avgFeedbackCount = usageReportResponse.avgFeedbackCount || 0;
        row.totalSearchCount = usageReportResponse.totalSearchCount || 0;
        row.avgSearchResults = usageReportResponse.avgSearchResults || 0;
        row.lastSearchDate = IS_NOT_NULL_OR_UNDEFINED(usageReportResponse.lastSearchDate)
            ? DATE_YMD(usageReportResponse.lastSearchDate)
            : '';
        row.lastCarrierContacted = usageReportResponse.lastCarrierContacted;
        row.noOfCarriersContacted = usageReportResponse.noOfCarriersContacted;
        results.push(row);
    });
    return results;
};

const USERS_LIST_FOR_POPOVER = ({ users, assigneeId, removeHavingStatus, }) => {
    let usersList = [];
    if (IS_NOT_NULL_OR_UNDEFINED(users) && users.length > 0) {
        users
            .filter((user) => user.accountStatus != removeHavingStatus)
            .map((user) => {
            let owner = {};
            owner.userId = user.id;
            if (IS_EMPTY(user.firstName) && IS_EMPTY(user.lastName)) {
                owner.name = user.email;
            }
            else {
                owner.name = `${user.firstName || ''} ${user.lastName || ''}`;
            }
            owner.selected = IS_NOT_NULL_OR_UNDEFINED(assigneeId) && user.id == assigneeId;
            owner.role = user.role;
            usersList.push(owner);
        });
        usersList = usersList.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1));
    }
    return usersList;
};

var TASK_STATUS_UUID;
(function (TASK_STATUS_UUID) {
    TASK_STATUS_UUID["098c14db-3ca5-4c7b-9d3a-556c1f02e1b9"] = "To Do";
    TASK_STATUS_UUID["a35b1fc4-6edd-42a7-a41a-0145d1dc3bde"] = "In Progress";
    TASK_STATUS_UUID["1a9b673e-ef5c-4666-a091-84e6d75e638d"] = "Done";
    TASK_STATUS_UUID["8b44dfa0-cbb8-4a2b-ad48-146f97c5555f"] = "Cancelled";
})(TASK_STATUS_UUID || (TASK_STATUS_UUID = {}));
const TASK_STATUS_UUID_MAP = {
    TO_DO: '098c14db-3ca5-4c7b-9d3a-556c1f02e1b9',
    IN_PROGRESS: 'a35b1fc4-6edd-42a7-a41a-0145d1dc3bde',
    DONE: '1a9b673e-ef5c-4666-a091-84e6d75e638d',
    CANCELLED: '8b44dfa0-cbb8-4a2b-ad48-146f97c5555f',
};

const TASK_FILTER_CONSTANTS = {
    OPEN: 'OPEN',
    DUE_TODAY: 'DUE_TODAY',
    DUE_THIS_WEEK: 'DUE_THIS_WEEK',
    OVERDUE: 'OVERDUE',
    DONE: 'DONE',
};

const TASK_TABLE = (taskDTOs = []) => {
    let results = [];
    if (taskDTOs.length > 0) {
        taskDTOs.forEach((taskDTO) => {
            let row = {};
            row.id = taskDTO.id;
            row.status = TASK_STATUS_UUID[taskDTO.statusId];
            row.title = taskDTO.title;
            row.projectName = IS_NOT_NULL_OR_UNDEFINED(taskDTO.project) ? taskDTO.project.name : '';
            row.carrierName = IS_NOT_NULL_OR_UNDEFINED(taskDTO.carrier)
                ? taskDTO.carrier.businessName
                : '';
            row.dueDate = IS_NOT_NULL_OR_UNDEFINED(taskDTO.dueDate)
                ? DATE_MDY(new Date(DATE_MDY(taskDTO.dueDate)))
                : '';
            row.assigneeId = taskDTO.assigneeId;
            row.projectId = IS_NOT_NULL_OR_UNDEFINED(taskDTO.project) ? taskDTO.project.id : '';
            row.carrierId = IS_NOT_NULL_OR_UNDEFINED(taskDTO.carrier) ? taskDTO.carrier.id : '';
            row.createdById = taskDTO.userId;
            results.push(row);
        });
    }
    return results;
};

const GET_TASK_FILTER = (taskFilterConstant, accountId) => {
    let taskFilter = {};
    taskFilter.accountId = accountId;
    taskFilter.statusIds = [TASK_STATUS_UUID_MAP.IN_PROGRESS, TASK_STATUS_UUID_MAP.TO_DO];
    switch (taskFilterConstant) {
        case TASK_FILTER_CONSTANTS.DUE_TODAY:
            taskFilter.startDate = DATE_YMD(TODAY());
            taskFilter.endDate = DATE_YMD(TODAY());
            break;
        case TASK_FILTER_CONSTANTS.DUE_THIS_WEEK:
            taskFilter.startDate = DATE_YMD(TODAY());
            taskFilter.endDate = DATE_YMD(AFTER_7_DAYS());
            break;
        case TASK_FILTER_CONSTANTS.OVERDUE:
            const YESTERDAY = SUBTRACT_DAYS_FROM_TODAY(1);
            taskFilter.endDate = DATE_YMD(YESTERDAY);
            break;
        case TASK_FILTER_CONSTANTS.DONE:
            taskFilter.statusIds = [TASK_STATUS_UUID_MAP.DONE];
            break;
    }
    return taskFilter;
};

const CARRIERS_SCORECARDS_TABLE = (lanesList = []) => {
    let results = [];
    if (lanesList.length > 0) {
        lanesList.map((load) => {
            let row = {};
            row.carrierName = '';
            row.carrierId = load.carrierId;
            row.carrierRepresentativeCount = load.carrierRepresentativeCount;
            row.loadsCount = load.loadsCount;
            row.customersCount = load.customersCount;
            row.allInCost = load.allInCost;
            row.predictedPrice = load.predictedPrice;
            row.totalBuy = IS_NOT_NULL_OR_UNDEFINED(row.allInCost) ? row.allInCost / 100 : null;
            row.forecastBuy = IS_NOT_NULL_OR_UNDEFINED(row.predictedPrice)
                ? row.predictedPrice / 100
                : null;
            row.expectedMargin = IS_NOT_NULL_OR_UNDEFINED(load.expectedMargin)
                ? load.expectedMargin / 100
                : null;
            row.actualMargin = IS_NOT_NULL_OR_UNDEFINED(load.actualMargin)
                ? load.actualMargin / 100
                : null;
            row.percentOfCost = null;
            row.carrierName = IS_NULL_OR_UNDEFINED(load.carrierId)
                ? 'Unidentified'
                : IS_NOT_EMPTY(load.carrierName)
                    ? load.carrierName
                    : 'N/A';
            row.revenue = IS_NOT_NULL_OR_UNDEFINED(load.priceToShipper)
                ? load.priceToShipper / 100
                : null;
            results.push(row);
        });
    }
    return results;
};

const CUSTOMERS_SCORECARDS_TABLE = (lanesList = []) => {
    let results = [];
    if (lanesList.length > 0) {
        lanesList.map((load) => {
            let row = {};
            row.customerName = '';
            row.customerId = load.customerId;
            row.accountExecsId = load.accountExecsId;
            row.accountExecutive = `${CAMEL_CASE(load.firstName)} ${CAMEL_CASE(load.lastName)}`;
            row.carriersCount = load.carriersCount;
            row.loadsCount = load.loadsCount;
            row.allInCost = load.allInCost;
            row.predictedPrice = load.predictedPrice;
            row.totalBuy = IS_NOT_NULL_OR_UNDEFINED(row.allInCost) ? row.allInCost / 100 : null;
            row.forecastBuy = IS_NOT_NULL_OR_UNDEFINED(row.predictedPrice)
                ? row.predictedPrice / 100
                : null;
            row.expectedMargin = IS_NOT_NULL_OR_UNDEFINED(load.expectedMargin)
                ? load.expectedMargin / 100
                : null;
            row.actualMargin = IS_NOT_NULL_OR_UNDEFINED(load.actualMargin)
                ? load.actualMargin / 100
                : null;
            row.percentOfRevenue = null;
            row.targetRevenue =
                IS_NOT_NULL_OR_UNDEFINED(load.targetRevenue) && load.targetRevenue > 0
                    ? load.targetRevenue / 100
                    : 0;
            row.customerName = IS_NULL_OR_UNDEFINED(load.customerId)
                ? 'Unidentified'
                : IS_NOT_EMPTY(load.customerName)
                    ? load.customerName
                    : 'N/A';
            row.revenue = IS_NOT_NULL_OR_UNDEFINED(load.priceToShipper)
                ? load.priceToShipper / 100
                : null;
            results.push(row);
        });
    }
    return results;
};

const LANES_SCORECARDS_TABLE = (lanesList = []) => {
    let results = [];
    if (lanesList.length > 0) {
        lanesList.map((lane) => {
            let row = {};
            row.origin = `${CAMEL_CASE(lane.originCity)}, ${lane.originState.toUpperCase()}`;
            row.destination = `${CAMEL_CASE(lane.destinationCity)}, ${lane.destinationState.toUpperCase()}`;
            row.laneId = lane.laneId;
            row.loadsCount = lane.loadsCount;
            row.carriersCount = lane.carriersCount;
            row.totalBuy = IS_NOT_NULL_OR_UNDEFINED(lane.allInCost) ? lane.allInCost / 100 : null;
            row.forecastBuy = IS_NOT_NULL_OR_UNDEFINED(lane.predictedPrice)
                ? lane.predictedPrice / 100
                : null;
            row.expectedMargin = IS_NOT_NULL_OR_UNDEFINED(lane.expectedMargin)
                ? lane.expectedMargin / 100
                : null;
            row.actualMargin = IS_NOT_NULL_OR_UNDEFINED(lane.actualMargin)
                ? lane.actualMargin / 100
                : null;
            row.revenue = IS_NOT_NULL_OR_UNDEFINED(lane.priceToShipper)
                ? lane.priceToShipper / 100
                : null;
            results.push(row);
        });
    }
    return results;
};

var INTEGRATION_TYPE;
(function (INTEGRATION_TYPE) {
    INTEGRATION_TYPE["MY_CARRIER_PACKETS"] = "MY_CARRIER_PACKETS";
    INTEGRATION_TYPE["MCLEOD"] = "MCLEOD";
    INTEGRATION_TYPE["BLUE_YONDER"] = "BLUE_YONDER";
    INTEGRATION_TYPE["MERCURY_GATE"] = "MERCURY_GATE";
    INTEGRATION_TYPE["TAI"] = "TAI";
    INTEGRATION_TYPE["OMNIS"] = "OMNIS";
    INTEGRATION_TYPE["THREE_PL_SYSTEMS"] = "THREE_PL_SYSTEMS";
    INTEGRATION_TYPE["FMS"] = "FMS";
    INTEGRATION_TYPE["LOGISTICALLY"] = "LOGISTICALLY";
    INTEGRATION_TYPE["ALJEX"] = "ALJEX";
    INTEGRATION_TYPE["TURVO"] = "TURVO";
    INTEGRATION_TYPE["BROKER_PRO"] = "BROKER_PRO";
    INTEGRATION_TYPE["AMAZON_FREIGHT"] = "AMAZON_FREIGHT";
    INTEGRATION_TYPE["GREEN_SCREENS"] = "GREEN_SCREENS";
    INTEGRATION_TYPE["RMIS"] = "RMIS";
})(INTEGRATION_TYPE || (INTEGRATION_TYPE = {}));

var INTEGRATION_CATEGORY;
(function (INTEGRATION_CATEGORY) {
    INTEGRATION_CATEGORY["TMS"] = "TMS";
    INTEGRATION_CATEGORY["VETTING"] = "VETTING";
    INTEGRATION_CATEGORY["PRIVATE_FLEETS"] = "PRIVATE_FLEETS";
    INTEGRATION_CATEGORY["PRICING"] = "PRICING";
})(INTEGRATION_CATEGORY || (INTEGRATION_CATEGORY = {}));

var CARRIER_RECRUITER_LOG_STAGE_UUID;
(function (CARRIER_RECRUITER_LOG_STAGE_UUID) {
    CARRIER_RECRUITER_LOG_STAGE_UUID["8ad358fc-869c-4847-89f3-101dc6071f72"] = "Carrier Added";
    CARRIER_RECRUITER_LOG_STAGE_UUID["aa60a24c-a02a-4ac4-a7f3-155a714cad8b"] = "Excluded";
    CARRIER_RECRUITER_LOG_STAGE_UUID["6f86f741-8c76-4450-934a-c667472d82bc"] = "Final Call";
    CARRIER_RECRUITER_LOG_STAGE_UUID["4ff38b07-ec55-46c6-8a1f-7d35678cdbc1"] = "First Call";
    CARRIER_RECRUITER_LOG_STAGE_UUID["3c8bf55f-4f9f-47d8-9193-f23aeb959208"] = "Lanes Added";
    CARRIER_RECRUITER_LOG_STAGE_UUID["df0f0078-277b-4ec6-bfe1-db0ee459d120"] = "Onboarded";
})(CARRIER_RECRUITER_LOG_STAGE_UUID || (CARRIER_RECRUITER_LOG_STAGE_UUID = {}));
const CARRIER_RECRUITER_LOG_STAGE_UUID_MAP = {
    CARRIER_ADDED: '8ad358fc-869c-4847-89f3-101dc6071f72',
    EXCLUDED: 'aa60a24c-a02a-4ac4-a7f3-155a714cad8b',
    FINAL_CALL: '6f86f741-8c76-4450-934a-c667472d82bc',
    FIRST_CALL: '4ff38b07-ec55-46c6-8a1f-7d35678cdbc1',
    LANES_ADDED: '3c8bf55f-4f9f-47d8-9193-f23aeb959208',
    ONBOARDED: 'df0f0078-277b-4ec6-bfe1-db0ee459d120',
};
const CARRIER_RECRUITER_STAGES = [
    {
        label: 'Carrier Added',
        value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.CARRIER_ADDED,
    },
    {
        label: 'Excluded',
        value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.EXCLUDED,
    },
    {
        label: 'Final Call',
        value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.FINAL_CALL,
    },
    {
        label: 'First Call',
        value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.FIRST_CALL,
    },
    {
        label: 'Lanes Added',
        value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.LANES_ADDED,
    },
    {
        label: 'Onboarded',
        value: CARRIER_RECRUITER_LOG_STAGE_UUID_MAP.ONBOARDED,
    },
];

const ADMIN_CARRIER_RECRUITER_LOG_TABLE = (carrierRecruiterLogs = [], accountUsers = []) => {
    let results = [];
    if (carrierRecruiterLogs.length > 0) {
        carrierRecruiterLogs.map((carrierRecruiterLog) => {
            let row = {};
            row.carrierId = carrierRecruiterLog.carrierId;
            row.created = DATE_MDY(carrierRecruiterLog.created);
            row.excluded = carrierRecruiterLog.excluded;
            row.excludedReason = carrierRecruiterLog.excludedReason;
            row.id = carrierRecruiterLog.id;
            row.nextContactDate = carrierRecruiterLog.nextContactDate
                ? DATE_MDY(carrierRecruiterLog.nextContactDate)
                : 'N/A';
            row.note = carrierRecruiterLog.note;
            row.onboarded = carrierRecruiterLog.onboarded
                ? DATE_MDY(carrierRecruiterLog.onboarded)
                : 'N/A';
            row.stageId = carrierRecruiterLog.stageId;
            row.stage = CARRIER_RECRUITER_LOG_STAGE_UUID[carrierRecruiterLog.stageId];
            row.userId = carrierRecruiterLog.userId;
            const user = accountUsers.find((user) => user.id === carrierRecruiterLog.userId);
            if (user) {
                row.user = `${user.firstName} ${user.lastName}`;
            }
            row.lastModified = DATE_MDY(carrierRecruiterLog.lastModified);
            results.push(row);
        });
    }
    return results;
};

var WEB_SOCKET_NOTIFICATION_TYPES;
(function (WEB_SOCKET_NOTIFICATION_TYPES) {
    WEB_SOCKET_NOTIFICATION_TYPES["INCORRECT_CONTACT"] = "INCORRECT_CONTACT";
    WEB_SOCKET_NOTIFICATION_TYPES["RFP"] = "RFP";
})(WEB_SOCKET_NOTIFICATION_TYPES || (WEB_SOCKET_NOTIFICATION_TYPES = {}));

const V2_PROJECTS = (projectDTOList = [], isAnnualVolumeEnabled = false, userId = null, usersList = []) => {
    let results = [];
    if (projectDTOList?.length > 0) {
        projectDTOList.map((projectDTO) => {
            const originCity = projectDTO.originCity, originState = projectDTO.originState, destCity = projectDTO.destCity, destState = projectDTO.destState;
            let project = {};
            project.id = projectDTO.id;
            project.startDate = DATE_MDY(projectDTO.dueDate);
            project.originCity = originCity;
            project.originState = originState;
            project.destinationCity = destCity;
            project.destinationState = destState;
            project.customerName = projectDTO?.customerDTO?.name || '-';
            project.monthlyVolumeDisplay = 'N/A';
            const annualVolume = ANNUAL_VOLUME_DISPLAY(projectDTO);
            if (annualVolume) {
                project.monthlyVolumeDisplay = `${Math.round(annualVolume / 12)}/Month`;
            }
            project.equipment = projectDTO.equipmentType?.replace(',', ', ').toUpperCase();
            project.commodity = projectDTO.commodity;
            project.weight = projectDTO.weight;
            project.customerRate = projectDTO.maxRate;
            project.targetCarrierRate = projectDTO.bestRate;
            project.procuredCarriers = projectDTO.carrierCount;
            project.assignedReps = 'unassigned';
            if (projectDTO.assigneeId) {
                const userAssigned = usersList?.find((user) => user.userId == projectDTO.assigneeId);
                if (userAssigned) {
                    project.assignedReps = userAssigned?.name;
                }
            }
            project.userId = projectDTO.userId;
            project.stageId = projectDTO.stageId;
            project.revenueCode = projectDTO.revenueCode;
            project.stageName = IS_NOT_EMPTY(project.stageId) ? PROJECT_STAGE_UUID[project.stageId] : '';
            project.type = IS_NOT_EMPTY(projectDTO.type) ? projectDTO.type.charAt(0) : '';
            if (IS_NOT_EMPTY(originCity) && IS_NOT_EMPTY(originState)) {
                project.origin = `${originCity}, ${originState}`;
            }
            if (IS_NOT_EMPTY(destCity) && IS_NOT_EMPTY(destState)) {
                project.destination = `${destCity}, ${destState}`;
            }
            results.push(project);
        });
    }
    return results;
};

const IMPORT_STATS_JOB_STATUS = {
    QUEUED: 'QUEUED',
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    FAILED: 'FAILED',
    LEGACY: 'LEGACY',
};

const IMPORT_STATS_TABLE = (importStatsList = [], usersList = []) => {
    let results = [];
    if (importStatsList.length > 0) {
        importStatsList.map((importStat) => {
            let row = {};
            row.c4UserId = importStat.c4UserId;
            if (row.c4UserId) {
                const user = usersList?.find((user) => user.userId == row.c4UserId);
                if (user) {
                    row.userName = user?.name;
                }
            }
            row.created = importStat.created;
            row.filename = importStat.filename;
            row.id = importStat.id;
            row.invalidRows = importStat.invalidRows;
            row.jobStatus = importStat.jobStatus;
            row.relativeUrl = importStat.relativeUrl;
            row.rowsFailed = importStat.rowsFailed;
            row.rowsInserted = importStat.rowsInserted;
            row.rowsParsed = importStat.rowsParsed;
            row.totalRows = importStat.totalRows;
            row.type = importStat.type;
            row.updated = importStat.updated;
            results.push(row);
        });
    }
    return results;
};

const PROJECT_IMPORT_STATS_TABLE = (projectImportStatsList = [], usersList = []) => {
    let results = [];
    if (projectImportStatsList.length > 0) {
        projectImportStatsList.map((projectImportStat) => {
            let row = {};
            row.userId = projectImportStat.userId;
            if (row.userId) {
                const user = usersList?.find((user) => user.userId == row.userId);
                if (user) {
                    row.userName = user?.name;
                }
            }
            row.created = projectImportStat.created;
            row.fileName = projectImportStat.fileName;
            row.id = projectImportStat.id;
            row.jobStatus = projectImportStat.jobStatus;
            row.rowsFailed = projectImportStat.rowsFailed;
            row.rowsInserted = projectImportStat.rowsInserted;
            row.rowsParsed = projectImportStat.rowsParsed;
            row.totalRows = projectImportStat.totalRows;
            row.lastModified = projectImportStat.lastModified;
            results.push(row);
        });
    }
    return results;
};

const DELAY = {
    IMMEDIATE: 'Immediate',
    MINS_5: '5 min',
    MINS_10: '10 minutes',
    MINS_30: '30 minutes',
    HOUR_1: '1 hour',
};
const DELAY_OPTIONS = [
    {
        label: DELAY.IMMEDIATE,
        value: 0,
    },
    {
        label: DELAY.MINS_5,
        value: 5,
    },
    {
        label: DELAY.MINS_10,
        value: 10,
    },
    {
        label: DELAY.MINS_30,
        value: 30,
    },
    {
        label: DELAY.HOUR_1,
        value: 60,
    },
];
const DELAY_CONTACT_LABELS = {
    '0': 'Immediately',
    '5': '5 mins later',
    '10': '10 minutes later',
    '30': '30 minutes later',
    '60': '1 hour later',
};

/*
 * Public API Surface of cargo-chief-commons
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACCOUNT_DETAILS_TYPE, ACCOUNT_DETAIL_FIELDS, ACCOUNT_SETTINGS_FIELD, ACTIVITY_LIST, ACTIVITY_TYPES, ACTIVITY_TYPE_MESSAGE, ADD_DAYS, ADMIN_ACCOUNTS_LIST_TABLE, ADMIN_ACCOUNT_DETAILS_LIST_TABLE, ADMIN_CAPACITY_EMAIL_LIST_TABLE, ADMIN_CARRIER_LIST_TABLE, ADMIN_CARRIER_RECRUITER_LOG_TABLE, ADMIN_LANES_CARRIERS_TABLE, ADMIN_LANES_LIST_TABLE, ADMIN_LANE_SEARCHES_TABLE, ADMIN_LANE_SEARCH_DETAILS__TABLE, ADMIN_LANE_SEARCH_LIST_TABLE, ADMIN_OAUTH_LIST_TABLE, ADMIN_TRUCK_SEARCHES_LIST_TABLE, ADMIN_TRUCK_SEARCH_RESULTS_LIST_TABLE, AFTER_30_DAYS, AFTER_7_DAYS, AFTER_90_DAYS, ANNUAL_VOLUME_DISPLAY, BID_DETAILS_TABLE, BID_DISPLAY_STATUS_CONSTANTS, BID_SOURCE_TYPE, BID_STATUS_STRING, BID_STATUS_UUID, BROKER_LANE_DETAILS_TABLE, BROKER_PROJECTS_TABLE, BULK_CAPACITY_MATCH_JOB_TABLE, BidViewTemplate, BulkCapacityMatchJobStatus, CALCULATE_TRANSIT_DAYS, CAMEL_CASE, CARRIERS_SCORECARDS_TABLE, CARRIER_BID_ACTIVITY, CARRIER_BID_TABLE, CARRIER_LANES_LIST_TABLE, CARRIER_LIST_TABLE, CARRIER_RECRUITER_LOG_STAGE_UUID, CARRIER_RECRUITER_LOG_STAGE_UUID_MAP, CARRIER_RECRUITER_STAGES, CLIENT_PROFILE_ROWS, COLUMNS_VIEW, CUSTOMERS_SCORECARDS_TABLE, CargoChiefCommonsModule, CargoChiefCommonsService, DATE_MDY, DATE_MDY_LOCAL, DATE_TIME, DATE_YMD, DELAY, DELAY_CONTACT_LABELS, DELAY_OPTIONS, DIFFERENCE_FROM_NOW, DIFFERENCE_IN_DAYS, DISPLAY_STATUSES, END_OF_MONTH, END_OF_MONTH_MOMENT_OBJ, END_OF_NEXT_MONTH, ENUMERATE_DAYS_BETWEEN_DATES, EQUALS_IGNORE_CASE, EXCLUDED_CARRIERS_TABLE, FORMAT_DATE, FROM_UTC, FULL_NAME, GET_CARRIER_BUSINESS_NAME, GET_CITY_STATE_FROM_LOCATION_STRING, GET_LANE_PATH_STRING, GET_LOAD_VOLUME, GET_MOMENT, GET_NAME_FROM_LANE_AND_EQIUPMENT, GET_PROJECTED_MARGIN, GET_QUERY_PARAMS, GET_TASK_FILTER, GET_TIME_ZONE_LABEL, GET_UNIX_TIMESTAMP, GET_UTC_DATE, HISTORICAL_LOADS_TABLE, HOT_LANE_TABLE, HQ_LOCATION_PARSER, IMPORT_STATS_JOB_STATUS, IMPORT_STATS_TABLE, INTEGRATION_CATEGORY, INTEGRATION_TYPE, IS_EMPTY, IS_EXISTING_DATE, IS_LESS_THAN_CURRENT_TIMESTAMP, IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED, IS_VALID_DATE, LANES_SCORECARDS_TABLE, LOAD_DISPLAY_STATUS_CONSTANTS, LOAD_STATUS, LOAD_STATUS_STRING, LOAD_VOLUME_DURATION, LOCATION_PARSER, LOCATION_PARSER_WITHOUT_ZIP, MAP_ACTIVITY_TYPE, MY_LOADS_TABLE, NOTIFICATION_MESSAGE, NOTIFICATION_TYPES, OPPORTUNITY_VALUE, POPULATE_DESTINATION, POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE, POPULATE_ORIGIN, PROJECT_CARRIER_MAP_STATUS, PROJECT_IMPORT_STATS_TABLE, PROJECT_POSITIONS, PROJECT_STAGE_UUID, PROJECT_STAGE_UUID_MAP, QUICK_SEARCH_ACCOUNTS_TABLE, QUICK_SEARCH_TABLE, QUOTE_STATUS, QUOTE_STATUS_STRING, QuoteViewTemplate, RECENT_TRANSACTIONS_TABLE, REVIEW_TRUCK_LIST_TABLE, RestService, SEARCH_CARRIER_ONLY_TABLE, SEARCH_TRUCK_TABLE, SET_TIME_TO_END_OF_THE_DAY, SET_TIME_TO_START_OF_THE_DAY, START_OF_MONTH, START_OF_NEXT_MONTH, SUBTRACT_DAYS_FROM_TODAY, SnackbarService, TASK_FILTER_CONSTANTS, TASK_STATUS_UUID, TASK_STATUS_UUID_MAP, TASK_TABLE, TIMESTAMP_FROM_STRING, TIME_ZONES, TITLE_CASE, TODAY, TOMORROW, TO_CENTS, TO_DOLLARS, TO_UTC, UPDATE_PROJECT_BY_USERID, USAGE_REPORT_TABLE, USERS_LIST_FOR_POPOVER, V2_PROJECTS, VETTING_SOURCE, WEB_SOCKET_NOTIFICATION_TYPES, YESTERDAY, YMD_TO_MOMENT, getCustomerCode };
